
export enum TimeZoneEnum {
    Africa_Abidjan = "Africa/Abidjan",
    Africa_Accra = "Africa/Accra",
    Africa_Addis_Ababa = "Africa/Addis_Ababa",
    Africa_Algiers = "Africa/Algiers",
    Africa_Asmara = "Africa/Asmara",
    Africa_Bamako = "Africa/Bamako",
    Africa_Bangui = "Africa/Bangui",
    Africa_Banjul = "Africa/Banjul",
    Africa_Bissau = "Africa/Bissau",
    Africa_Blantyre = "Africa/Blantyre",
    Africa_Brazzaville = "Africa/Brazzaville",
    Africa_Bujumbura = "Africa/Bujumbura",
    Africa_Cairo = "Africa/Cairo",
    Africa_Casablanca = "Africa/Casablanca",
    Africa_Ceuta = "Africa/Ceuta",
    Africa_Conakry = "Africa/Conakry",
    Africa_Dakar = "Africa/Dakar",
    Africa_Dar_es_Salaam = "Africa/Dar_es_Salaam",
    Africa_Djibouti = "Africa/Djibouti",
    Africa_Douala = "Africa/Douala",
    Africa_El_Aaiun = "Africa/El_Aaiun",
    Africa_Freetown = "Africa/Freetown",
    Africa_Gaborone = "Africa/Gaborone",
    Africa_Harare = "Africa/Harare",
    Africa_Johannesburg = "Africa/Johannesburg",
    Africa_Juba = "Africa/Juba",
    Africa_Kampala = "Africa/Kampala",
    Africa_Khartoum = "Africa/Khartoum",
    Africa_Kigali = "Africa/Kigali",
    Africa_Kinshasa = "Africa/Kinshasa",
    Africa_Lagos = "Africa/Lagos",
    Africa_Libreville = "Africa/Libreville",
    Africa_Lome = "Africa/Lome",
    Africa_Luanda = "Africa/Luanda",
    Africa_Lubumbashi = "Africa/Lubumbashi",
    Africa_Lusaka = "Africa/Lusaka",
    Africa_Malabo = "Africa/Malabo",
    Africa_Maputo = "Africa/Maputo",
    Africa_Maseru = "Africa/Maseru",
    Africa_Mbabane = "Africa/Mbabane",
    Africa_Mogadishu = "Africa/Mogadishu",
    Africa_Monrovia = "Africa/Monrovia",
    Africa_Nairobi = "Africa/Nairobi",
    Africa_Ndjamena = "Africa/Ndjamena",
    Africa_Niamey = "Africa/Niamey",
    Africa_Nouakchott = "Africa/Nouakchott",
    Africa_Ouagadougou = "Africa/Ouagadougou",
    Africa_Porto_Novo = "Africa/Porto-Novo",
    Africa_Sao_Tome = "Africa/Sao_Tome",
    Africa_Tripoli = "Africa/Tripoli",
    Africa_Tunis = "Africa/Tunis",
    Africa_Windhoek = "Africa/Windhoek",
    America_Adak = "America/Adak",
    America_Anchorage = "America/Anchorage",
    America_Anguilla = "America/Anguilla",
    America_Antigua = "America/Antigua",
    America_Araguaina = "America/Araguaina",
    America_Argentina_Buenos_Aires = "America/Argentina/Buenos_Aires",
    America_Argentina_Catamarca = "America/Argentina/Catamarca",
    America_Argentina_Cordoba = "America/Argentina/Cordoba",
    America_Argentina_Jujuy = "America/Argentina/Jujuy",
    America_Argentina_La_Rioja = "America/Argentina/La_Rioja",
    America_Argentina_Mendoza = "America/Argentina/Mendoza",
    America_Argentina_Rio_Gallegos = "America/Argentina/Rio_Gallegos",
    America_Argentina_Salta = "America/Argentina/Salta",
    America_Argentina_San_Juan = "America/Argentina/San_Juan",
    America_Argentina_San_Luis = "America/Argentina/San_Luis",
    America_Argentina_Tucuman = "America/Argentina/Tucuman",
    America_Argentina_Ushuaia = "America/Argentina/Ushuaia",
    America_Aruba = "America/Aruba",
    America_Asuncion = "America/Asuncion",
    America_Atikokan = "America/Atikokan",
    America_Bahia = "America/Bahia",
    America_Bahia_Banderas = "America/Bahia_Banderas",
    America_Barbados = "America/Barbados",
    America_Belem = "America/Belem",
    America_Belize = "America/Belize",
    America_Blanc_Sablon = "America/Blanc-Sablon",
    America_Boa_Vista = "America/Boa_Vista",
    America_Bogota = "America/Bogota",
    America_Boise = "America/Boise",
    America_Cambridge_Bay = "America/Cambridge_Bay",
    America_Campo_Grande = "America/Campo_Grande",
    America_Cancun = "America/Cancun",
    America_Caracas = "America/Caracas",
    America_Cayenne = "America/Cayenne",
    America_Cayman = "America/Cayman",
    America_Chicago = "America/Chicago",
    America_Chihuahua = "America/Chihuahua",
    America_Ciudad_Juarez = "America/Ciudad_Juarez",
    America_Costa_Rica = "America/Costa_Rica",
    America_Creston = "America/Creston",
    America_Cuiaba = "America/Cuiaba",
    America_Curacao = "America/Curacao",
    America_Danmarkshavn = "America/Danmarkshavn",
    America_Dawson = "America/Dawson",
    America_Dawson_Creek = "America/Dawson_Creek",
    America_Denver = "America/Denver",
    America_Detroit = "America/Detroit",
    America_Dominica = "America/Dominica",
    America_Edmonton = "America/Edmonton",
    America_Eirunepe = "America/Eirunepe",
    America_El_Salvador = "America/El_Salvador",
    America_Fort_Nelson = "America/Fort_Nelson",
    America_Fortaleza = "America/Fortaleza",
    America_Glace_Bay = "America/Glace_Bay",
    America_Goose_Bay = "America/Goose_Bay",
    America_Grand_Turk = "America/Grand_Turk",
    America_Grenada = "America/Grenada",
    America_Guadeloupe = "America/Guadeloupe",
    America_Guatemala = "America/Guatemala",
    America_Guayaquil = "America/Guayaquil",
    America_Guyana = "America/Guyana",
    America_Halifax = "America/Halifax",
    America_Havana = "America/Havana",
    America_Hermosillo = "America/Hermosillo",
    America_Indiana_Indianapolis = "America/Indiana/Indianapolis",
    America_Indiana_Knox = "America/Indiana/Knox",
    America_Indiana_Marengo = "America/Indiana/Marengo",
    America_Indiana_Petersburg = "America/Indiana/Petersburg",
    America_Indiana_Tell_City = "America/Indiana/Tell_City",
    America_Indiana_Vevay = "America/Indiana/Vevay",
    America_Indiana_Vincennes = "America/Indiana/Vincennes",
    America_Indiana_Winamac = "America/Indiana/Winamac",
    America_Inuvik = "America/Inuvik",
    America_Iqaluit = "America/Iqaluit",
    America_Jamaica = "America/Jamaica",
    America_Juneau = "America/Juneau",
    America_Kentucky_Louisville = "America/Kentucky/Louisville",
    America_Kentucky_Monticello = "America/Kentucky/Monticello",
    America_Kralendijk = "America/Kralendijk",
    America_La_Paz = "America/La_Paz",
    America_Lima = "America/Lima",
    America_Los_Angeles = "America/Los_Angeles",
    America_Lower_Princes = "America/Lower_Princes",
    America_Maceio = "America/Maceio",
    America_Managua = "America/Managua",
    America_Manaus = "America/Manaus",
    America_Marigot = "America/Marigot",
    America_Martinique = "America/Martinique",
    America_Matamoros = "America/Matamoros",
    America_Mazatlan = "America/Mazatlan",
    America_Menominee = "America/Menominee",
    America_Merida = "America/Merida",
    America_Metlakatla = "America/Metlakatla",
    America_Mexico_City = "America/Mexico_City",
    America_Miquelon = "America/Miquelon",
    America_Moncton = "America/Moncton",
    America_Monterrey = "America/Monterrey",
    America_Montevideo = "America/Montevideo",
    America_Montserrat = "America/Montserrat",
    America_Nassau = "America/Nassau",
    America_New_York = "America/New_York",
    America_Nome = "America/Nome",
    America_Noronha = "America/Noronha",
    America_North_Dakota_Beulah = "America/North_Dakota/Beulah",
    America_North_Dakota_Center = "America/North_Dakota/Center",
    America_North_Dakota_New_Salem = "America/North_Dakota/New_Salem",
    America_Nuuk = "America/Nuuk",
    America_Ojinaga = "America/Ojinaga",
    America_Panama = "America/Panama",
    America_Paramaribo = "America/Paramaribo",
    America_Phoenix = "America/Phoenix",
    America_Port_au_Prince = "America/Port-au-Prince",
    America_Port_of_Spain = "America/Port_of_Spain",
    America_Porto_Velho = "America/Porto_Velho",
    America_Puerto_Rico = "America/Puerto_Rico",
    America_Punta_Arenas = "America/Punta_Arenas",
    America_Rankin_Inlet = "America/Rankin_Inlet",
    America_Recife = "America/Recife",
    America_Regina = "America/Regina",
    America_Resolute = "America/Resolute",
    America_Rio_Branco = "America/Rio_Branco",
    America_Santarem = "America/Santarem",
    America_Santiago = "America/Santiago",
    America_Santo_Domingo = "America/Santo_Domingo",
    America_Sao_Paulo = "America/Sao_Paulo",
    America_Scoresbysund = "America/Scoresbysund",
    America_Sitka = "America/Sitka",
    America_St_Barthelemy = "America/St_Barthelemy",
    America_St_Johns = "America/St_Johns",
    America_St_Kitts = "America/St_Kitts",
    America_St_Lucia = "America/St_Lucia",
    America_St_Thomas = "America/St_Thomas",
    America_St_Vincent = "America/St_Vincent",
    America_Swift_Current = "America/Swift_Current",
    America_Tegucigalpa = "America/Tegucigalpa",
    America_Thule = "America/Thule",
    America_Tijuana = "America/Tijuana",
    America_Toronto = "America/Toronto",
    America_Tortola = "America/Tortola",
    America_Vancouver = "America/Vancouver",
    America_Whitehorse = "America/Whitehorse",
    America_Winnipeg = "America/Winnipeg",
    America_Yakutat = "America/Yakutat",
    Antarctica_Casey = "Antarctica/Casey",
    Antarctica_Davis = "Antarctica/Davis",
    Antarctica_DumontDUrville = "Antarctica/DumontDUrville",
    Antarctica_Macquarie = "Antarctica/Macquarie",
    Antarctica_Mawson = "Antarctica/Mawson",
    Antarctica_McMurdo = "Antarctica/McMurdo",
    Antarctica_Palmer = "Antarctica/Palmer",
    Antarctica_Rothera = "Antarctica/Rothera",
    Antarctica_Syowa = "Antarctica/Syowa",
    Antarctica_Troll = "Antarctica/Troll",
    Antarctica_Vostok = "Antarctica/Vostok",
    Arctic_Longyearbyen = "Arctic/Longyearbyen",
    Asia_Aden = "Asia/Aden",
    Asia_Almaty = "Asia/Almaty",
    Asia_Amman = "Asia/Amman",
    Asia_Anadyr = "Asia/Anadyr",
    Asia_Aqtau = "Asia/Aqtau",
    Asia_Aqtobe = "Asia/Aqtobe",
    Asia_Ashgabat = "Asia/Ashgabat",
    Asia_Atyrau = "Asia/Atyrau",
    Asia_Baghdad = "Asia/Baghdad",
    Asia_Bahrain = "Asia/Bahrain",
    Asia_Baku = "Asia/Baku",
    Asia_Bangkok = "Asia/Bangkok",
    Asia_Barnaul = "Asia/Barnaul",
    Asia_Beirut = "Asia/Beirut",
    Asia_Bishkek = "Asia/Bishkek",
    Asia_Brunei = "Asia/Brunei",
    Asia_Chita = "Asia/Chita",
    Asia_Colombo = "Asia/Colombo",
    Asia_Damascus = "Asia/Damascus",
    Asia_Dhaka = "Asia/Dhaka",
    Asia_Dili = "Asia/Dili",
    Asia_Dubai = "Asia/Dubai",
    Asia_Dushanbe = "Asia/Dushanbe",
    Asia_Famagusta = "Asia/Famagusta",
    Asia_Gaza = "Asia/Gaza",
    Asia_Hebron = "Asia/Hebron",
    Asia_Ho_Chi_Minh = "Asia/Ho_Chi_Minh",
    Asia_Hong_Kong = "Asia/Hong_Kong",
    Asia_Hovd = "Asia/Hovd",
    Asia_Irkutsk = "Asia/Irkutsk",
    Asia_Jakarta = "Asia/Jakarta",
    Asia_Jayapura = "Asia/Jayapura",
    Asia_Jerusalem = "Asia/Jerusalem",
    Asia_Kabul = "Asia/Kabul",
    Asia_Kamchatka = "Asia/Kamchatka",
    Asia_Karachi = "Asia/Karachi",
    Asia_Kathmandu = "Asia/Kathmandu",
    Asia_Khandyga = "Asia/Khandyga",
    Asia_Kolkata = "Asia/Kolkata",
    Asia_Krasnoyarsk = "Asia/Krasnoyarsk",
    Asia_Kuala_Lumpur = "Asia/Kuala_Lumpur",
    Asia_Kuching = "Asia/Kuching",
    Asia_Kuwait = "Asia/Kuwait",
    Asia_Macau = "Asia/Macau",
    Asia_Magadan = "Asia/Magadan",
    Asia_Makassar = "Asia/Makassar",
    Asia_Manila = "Asia/Manila",
    Asia_Muscat = "Asia/Muscat",
    Asia_Nicosia = "Asia/Nicosia",
    Asia_Novokuznetsk = "Asia/Novokuznetsk",
    Asia_Novosibirsk = "Asia/Novosibirsk",
    Asia_Omsk = "Asia/Omsk",
    Asia_Oral = "Asia/Oral",
    Asia_Phnom_Penh = "Asia/Phnom_Penh",
    Asia_Pontianak = "Asia/Pontianak",
    Asia_Pyongyang = "Asia/Pyongyang",
    Asia_Qatar = "Asia/Qatar",
    Asia_Qostanay = "Asia/Qostanay",
    Asia_Qyzylorda = "Asia/Qyzylorda",
    Asia_Riyadh = "Asia/Riyadh",
    Asia_Sakhalin = "Asia/Sakhalin",
    Asia_Samarkand = "Asia/Samarkand",
    Asia_Seoul = "Asia/Seoul",
    Asia_Shanghai = "Asia/Shanghai",
    Asia_Singapore = "Asia/Singapore",
    Asia_Srednekolymsk = "Asia/Srednekolymsk",
    Asia_Taipei = "Asia/Taipei",
    Asia_Tashkent = "Asia/Tashkent",
    Asia_Tbilisi = "Asia/Tbilisi",
    Asia_Tehran = "Asia/Tehran",
    Asia_Thimphu = "Asia/Thimphu",
    Asia_Tokyo = "Asia/Tokyo",
    Asia_Tomsk = "Asia/Tomsk",
    Asia_Ulaanbaatar = "Asia/Ulaanbaatar",
    Asia_Urumqi = "Asia/Urumqi",
    Asia_Ust_Nera = "Asia/Ust-Nera",
    Asia_Vientiane = "Asia/Vientiane",
    Asia_Vladivostok = "Asia/Vladivostok",
    Asia_Yakutsk = "Asia/Yakutsk",
    Asia_Yangon = "Asia/Yangon",
    Asia_Yekaterinburg = "Asia/Yekaterinburg",
    Asia_Yerevan = "Asia/Yerevan",
    Atlantic_Azores = "Atlantic/Azores",
    Atlantic_Bermuda = "Atlantic/Bermuda",
    Atlantic_Canary = "Atlantic/Canary",
    Atlantic_Cape_Verde = "Atlantic/Cape_Verde",
    Atlantic_Faroe = "Atlantic/Faroe",
    Atlantic_Madeira = "Atlantic/Madeira",
    Atlantic_Reykjavik = "Atlantic/Reykjavik",
    Atlantic_South_Georgia = "Atlantic/South_Georgia",
    Atlantic_St_Helena = "Atlantic/St_Helena",
    Atlantic_Stanley = "Atlantic/Stanley",
    Australia_Adelaide = "Australia/Adelaide",
    Australia_Brisbane = "Australia/Brisbane",
    Australia_Broken_Hill = "Australia/Broken_Hill",
    Australia_Darwin = "Australia/Darwin",
    Australia_Eucla = "Australia/Eucla",
    Australia_Hobart = "Australia/Hobart",
    Australia_Lindeman = "Australia/Lindeman",
    Australia_Lord_Howe = "Australia/Lord_Howe",
    Australia_Melbourne = "Australia/Melbourne",
    Australia_Perth = "Australia/Perth",
    Australia_Sydney = "Australia/Sydney",
    Europe_Amsterdam = "Europe/Amsterdam",
    Europe_Andorra = "Europe/Andorra",
    Europe_Astrakhan = "Europe/Astrakhan",
    Europe_Athens = "Europe/Athens",
    Europe_Belgrade = "Europe/Belgrade",
    Europe_Berlin = "Europe/Berlin",
    Europe_Bratislava = "Europe/Bratislava",
    Europe_Brussels = "Europe/Brussels",
    Europe_Bucharest = "Europe/Bucharest",
    Europe_Budapest = "Europe/Budapest",
    Europe_Busingen = "Europe/Busingen",
    Europe_Chisinau = "Europe/Chisinau",
    Europe_Copenhagen = "Europe/Copenhagen",
    Europe_Dublin = "Europe/Dublin",
    Europe_Gibraltar = "Europe/Gibraltar",
    Europe_Guernsey = "Europe/Guernsey",
    Europe_Helsinki = "Europe/Helsinki",
    Europe_Isle_of_Man = "Europe/Isle_of_Man",
    Europe_Istanbul = "Europe/Istanbul",
    Europe_Jersey = "Europe/Jersey",
    Europe_Kaliningrad = "Europe/Kaliningrad",
    Europe_Kirov = "Europe/Kirov",
    Europe_Kyiv = "Europe/Kyiv",
    Europe_Lisbon = "Europe/Lisbon",
    Europe_Ljubljana = "Europe/Ljubljana",
    Europe_London = "Europe/London",
    Europe_Luxembourg = "Europe/Luxembourg",
    Europe_Madrid = "Europe/Madrid",
    Europe_Malta = "Europe/Malta",
    Europe_Mariehamn = "Europe/Mariehamn",
    Europe_Minsk = "Europe/Minsk",
    Europe_Monaco = "Europe/Monaco",
    Europe_Moscow = "Europe/Moscow",
    Europe_Oslo = "Europe/Oslo",
    Europe_Paris = "Europe/Paris",
    Europe_Podgorica = "Europe/Podgorica",
    Europe_Prague = "Europe/Prague",
    Europe_Riga = "Europe/Riga",
    Europe_Rome = "Europe/Rome",
    Europe_Samara = "Europe/Samara",
    Europe_San_Marino = "Europe/San_Marino",
    Europe_Sarajevo = "Europe/Sarajevo",
    Europe_Saratov = "Europe/Saratov",
    Europe_Simferopol = "Europe/Simferopol",
    Europe_Skopje = "Europe/Skopje",
    Europe_Sofia = "Europe/Sofia",
    Europe_Stockholm = "Europe/Stockholm",
    Europe_Tallinn = "Europe/Tallinn",
    Europe_Tirane = "Europe/Tirane",
    Europe_Ulyanovsk = "Europe/Ulyanovsk",
    Europe_Vaduz = "Europe/Vaduz",
    Europe_Vatican = "Europe/Vatican",
    Europe_Vienna = "Europe/Vienna",
    Europe_Vilnius = "Europe/Vilnius",
    Europe_Volgograd = "Europe/Volgograd",
    Europe_Warsaw = "Europe/Warsaw",
    Europe_Zagreb = "Europe/Zagreb",
    Europe_Zurich = "Europe/Zurich",
    Indian_Antananarivo = "Indian/Antananarivo",
    Indian_Chagos = "Indian/Chagos",
    Indian_Christmas = "Indian/Christmas",
    Indian_Cocos = "Indian/Cocos",
    Indian_Comoro = "Indian/Comoro",
    Indian_Kerguelen = "Indian/Kerguelen",
    Indian_Mahe = "Indian/Mahe",
    Indian_Maldives = "Indian/Maldives",
    Indian_Mauritius = "Indian/Mauritius",
    Indian_Mayotte = "Indian/Mayotte",
    Indian_Reunion = "Indian/Reunion",
    Pacific_Apia = "Pacific/Apia",
    Pacific_Auckland = "Pacific/Auckland",
    Pacific_Bougainville = "Pacific/Bougainville",
    Pacific_Chatham = "Pacific/Chatham",
    Pacific_Chuuk = "Pacific/Chuuk",
    Pacific_Easter = "Pacific/Easter",
    Pacific_Efate = "Pacific/Efate",
    Pacific_Fakaofo = "Pacific/Fakaofo",
    Pacific_Fiji = "Pacific/Fiji",
    Pacific_Funafuti = "Pacific/Funafuti",
    Pacific_Galapagos = "Pacific/Galapagos",
    Pacific_Gambier = "Pacific/Gambier",
    Pacific_Guadalcanal = "Pacific/Guadalcanal",
    Pacific_Guam = "Pacific/Guam",
    Pacific_Honolulu = "Pacific/Honolulu",
    Pacific_Kanton = "Pacific/Kanton",
    Pacific_Kiritimati = "Pacific/Kiritimati",
    Pacific_Kosrae = "Pacific/Kosrae",
    Pacific_Kwajalein = "Pacific/Kwajalein",
    Pacific_Majuro = "Pacific/Majuro",
    Pacific_Marquesas = "Pacific/Marquesas",
    Pacific_Midway = "Pacific/Midway",
    Pacific_Nauru = "Pacific/Nauru",
    Pacific_Niue = "Pacific/Niue",
    Pacific_Norfolk = "Pacific/Norfolk",
    Pacific_Noumea = "Pacific/Noumea",
    Pacific_Pago_Pago = "Pacific/Pago_Pago",
    Pacific_Palau = "Pacific/Palau",
    Pacific_Pitcairn = "Pacific/Pitcairn",
    Pacific_Pohnpei = "Pacific/Pohnpei",
    Pacific_Port_Moresby = "Pacific/Port_Moresby",
    Pacific_Rarotonga = "Pacific/Rarotonga",
    Pacific_Saipan = "Pacific/Saipan",
    Pacific_Tahiti = "Pacific/Tahiti",
    Pacific_Tarawa = "Pacific/Tarawa",
    Pacific_Tongatapu = "Pacific/Tongatapu",
    Pacific_Wake = "Pacific/Wake",
    Pacific_Wallis = "Pacific/Wallis",
    UTC = "UTC",
}

export const TimeZoneEnumData = {
    [TimeZoneEnum.Africa_Abidjan]: {
        key: TimeZoneEnum.Africa_Abidjan,
        value: "Africa/Abidjan",
        label: "Africa/Abidjan",
    },
    [TimeZoneEnum.Africa_Accra]: {
        key: TimeZoneEnum.Africa_Accra,
        value: "Africa/Accra",
        label: "Africa/Accra",
    },
    [TimeZoneEnum.Africa_Addis_Ababa]: {
        key: TimeZoneEnum.Africa_Addis_Ababa,
        value: "Africa/Addis_Ababa",
        label: "Africa/Addis_Ababa",
    },
    [TimeZoneEnum.Africa_Algiers]: {
        key: TimeZoneEnum.Africa_Algiers,
        value: "Africa/Algiers",
        label: "Africa/Algiers",
    },
    [TimeZoneEnum.Africa_Asmara]: {
        key: TimeZoneEnum.Africa_Asmara,
        value: "Africa/Asmara",
        label: "Africa/Asmara",
    },
    [TimeZoneEnum.Africa_Bamako]: {
        key: TimeZoneEnum.Africa_Bamako,
        value: "Africa/Bamako",
        label: "Africa/Bamako",
    },
    [TimeZoneEnum.Africa_Bangui]: {
        key: TimeZoneEnum.Africa_Bangui,
        value: "Africa/Bangui",
        label: "Africa/Bangui",
    },
    [TimeZoneEnum.Africa_Banjul]: {
        key: TimeZoneEnum.Africa_Banjul,
        value: "Africa/Banjul",
        label: "Africa/Banjul",
    },
    [TimeZoneEnum.Africa_Bissau]: {
        key: TimeZoneEnum.Africa_Bissau,
        value: "Africa/Bissau",
        label: "Africa/Bissau",
    },
    [TimeZoneEnum.Africa_Blantyre]: {
        key: TimeZoneEnum.Africa_Blantyre,
        value: "Africa/Blantyre",
        label: "Africa/Blantyre",
    },
    [TimeZoneEnum.Africa_Brazzaville]: {
        key: TimeZoneEnum.Africa_Brazzaville,
        value: "Africa/Brazzaville",
        label: "Africa/Brazzaville",
    },
    [TimeZoneEnum.Africa_Bujumbura]: {
        key: TimeZoneEnum.Africa_Bujumbura,
        value: "Africa/Bujumbura",
        label: "Africa/Bujumbura",
    },
    [TimeZoneEnum.Africa_Cairo]: {
        key: TimeZoneEnum.Africa_Cairo,
        value: "Africa/Cairo",
        label: "Africa/Cairo",
    },
    [TimeZoneEnum.Africa_Casablanca]: {
        key: TimeZoneEnum.Africa_Casablanca,
        value: "Africa/Casablanca",
        label: "Africa/Casablanca",
    },
    [TimeZoneEnum.Africa_Ceuta]: {
        key: TimeZoneEnum.Africa_Ceuta,
        value: "Africa/Ceuta",
        label: "Africa/Ceuta",
    },
    [TimeZoneEnum.Africa_Conakry]: {
        key: TimeZoneEnum.Africa_Conakry,
        value: "Africa/Conakry",
        label: "Africa/Conakry",
    },
    [TimeZoneEnum.Africa_Dakar]: {
        key: TimeZoneEnum.Africa_Dakar,
        value: "Africa/Dakar",
        label: "Africa/Dakar",
    },
    [TimeZoneEnum.Africa_Dar_es_Salaam]: {
        key: TimeZoneEnum.Africa_Dar_es_Salaam,
        value: "Africa/Dar_es_Salaam",
        label: "Africa/Dar_es_Salaam",
    },
    [TimeZoneEnum.Africa_Djibouti]: {
        key: TimeZoneEnum.Africa_Djibouti,
        value: "Africa/Djibouti",
        label: "Africa/Djibouti",
    },
    [TimeZoneEnum.Africa_Douala]: {
        key: TimeZoneEnum.Africa_Douala,
        value: "Africa/Douala",
        label: "Africa/Douala",
    },
    [TimeZoneEnum.Africa_El_Aaiun]: {
        key: TimeZoneEnum.Africa_El_Aaiun,
        value: "Africa/El_Aaiun",
        label: "Africa/El_Aaiun",
    },
    [TimeZoneEnum.Africa_Freetown]: {
        key: TimeZoneEnum.Africa_Freetown,
        value: "Africa/Freetown",
        label: "Africa/Freetown",
    },
    [TimeZoneEnum.Africa_Gaborone]: {
        key: TimeZoneEnum.Africa_Gaborone,
        value: "Africa/Gaborone",
        label: "Africa/Gaborone",
    },
    [TimeZoneEnum.Africa_Harare]: {
        key: TimeZoneEnum.Africa_Harare,
        value: "Africa/Harare",
        label: "Africa/Harare",
    },
    [TimeZoneEnum.Africa_Johannesburg]: {
        key: TimeZoneEnum.Africa_Johannesburg,
        value: "Africa/Johannesburg",
        label: "Africa/Johannesburg",
    },
    [TimeZoneEnum.Africa_Juba]: {
        key: TimeZoneEnum.Africa_Juba,
        value: "Africa/Juba",
        label: "Africa/Juba",
    },
    [TimeZoneEnum.Africa_Kampala]: {
        key: TimeZoneEnum.Africa_Kampala,
        value: "Africa/Kampala",
        label: "Africa/Kampala",
    },
    [TimeZoneEnum.Africa_Khartoum]: {
        key: TimeZoneEnum.Africa_Khartoum,
        value: "Africa/Khartoum",
        label: "Africa/Khartoum",
    },
    [TimeZoneEnum.Africa_Kigali]: {
        key: TimeZoneEnum.Africa_Kigali,
        value: "Africa/Kigali",
        label: "Africa/Kigali",
    },
    [TimeZoneEnum.Africa_Kinshasa]: {
        key: TimeZoneEnum.Africa_Kinshasa,
        value: "Africa/Kinshasa",
        label: "Africa/Kinshasa",
    },
    [TimeZoneEnum.Africa_Lagos]: {
        key: TimeZoneEnum.Africa_Lagos,
        value: "Africa/Lagos",
        label: "Africa/Lagos",
    },
    [TimeZoneEnum.Africa_Libreville]: {
        key: TimeZoneEnum.Africa_Libreville,
        value: "Africa/Libreville",
        label: "Africa/Libreville",
    },
    [TimeZoneEnum.Africa_Lome]: {
        key: TimeZoneEnum.Africa_Lome,
        value: "Africa/Lome",
        label: "Africa/Lome",
    },
    [TimeZoneEnum.Africa_Luanda]: {
        key: TimeZoneEnum.Africa_Luanda,
        value: "Africa/Luanda",
        label: "Africa/Luanda",
    },
    [TimeZoneEnum.Africa_Lubumbashi]: {
        key: TimeZoneEnum.Africa_Lubumbashi,
        value: "Africa/Lubumbashi",
        label: "Africa/Lubumbashi",
    },
    [TimeZoneEnum.Africa_Lusaka]: {
        key: TimeZoneEnum.Africa_Lusaka,
        value: "Africa/Lusaka",
        label: "Africa/Lusaka",
    },
    [TimeZoneEnum.Africa_Malabo]: {
        key: TimeZoneEnum.Africa_Malabo,
        value: "Africa/Malabo",
        label: "Africa/Malabo",
    },
    [TimeZoneEnum.Africa_Maputo]: {
        key: TimeZoneEnum.Africa_Maputo,
        value: "Africa/Maputo",
        label: "Africa/Maputo",
    },
    [TimeZoneEnum.Africa_Maseru]: {
        key: TimeZoneEnum.Africa_Maseru,
        value: "Africa/Maseru",
        label: "Africa/Maseru",
    },
    [TimeZoneEnum.Africa_Mbabane]: {
        key: TimeZoneEnum.Africa_Mbabane,
        value: "Africa/Mbabane",
        label: "Africa/Mbabane",
    },
    [TimeZoneEnum.Africa_Mogadishu]: {
        key: TimeZoneEnum.Africa_Mogadishu,
        value: "Africa/Mogadishu",
        label: "Africa/Mogadishu",
    },
    [TimeZoneEnum.Africa_Monrovia]: {
        key: TimeZoneEnum.Africa_Monrovia,
        value: "Africa/Monrovia",
        label: "Africa/Monrovia",
    },
    [TimeZoneEnum.Africa_Nairobi]: {
        key: TimeZoneEnum.Africa_Nairobi,
        value: "Africa/Nairobi",
        label: "Africa/Nairobi",
    },
    [TimeZoneEnum.Africa_Ndjamena]: {
        key: TimeZoneEnum.Africa_Ndjamena,
        value: "Africa/Ndjamena",
        label: "Africa/Ndjamena",
    },
    [TimeZoneEnum.Africa_Niamey]: {
        key: TimeZoneEnum.Africa_Niamey,
        value: "Africa/Niamey",
        label: "Africa/Niamey",
    },
    [TimeZoneEnum.Africa_Nouakchott]: {
        key: TimeZoneEnum.Africa_Nouakchott,
        value: "Africa/Nouakchott",
        label: "Africa/Nouakchott",
    },
    [TimeZoneEnum.Africa_Ouagadougou]: {
        key: TimeZoneEnum.Africa_Ouagadougou,
        value: "Africa/Ouagadougou",
        label: "Africa/Ouagadougou",
    },
    [TimeZoneEnum.Africa_Porto_Novo]: {
        key: TimeZoneEnum.Africa_Porto_Novo,
        value: "Africa/Porto-Novo",
        label: "Africa/Porto-Novo",
    },
    [TimeZoneEnum.Africa_Sao_Tome]: {
        key: TimeZoneEnum.Africa_Sao_Tome,
        value: "Africa/Sao_Tome",
        label: "Africa/Sao_Tome",
    },
    [TimeZoneEnum.Africa_Tripoli]: {
        key: TimeZoneEnum.Africa_Tripoli,
        value: "Africa/Tripoli",
        label: "Africa/Tripoli",
    },
    [TimeZoneEnum.Africa_Tunis]: {
        key: TimeZoneEnum.Africa_Tunis,
        value: "Africa/Tunis",
        label: "Africa/Tunis",
    },
    [TimeZoneEnum.Africa_Windhoek]: {
        key: TimeZoneEnum.Africa_Windhoek,
        value: "Africa/Windhoek",
        label: "Africa/Windhoek",
    },
    [TimeZoneEnum.America_Adak]: {
        key: TimeZoneEnum.America_Adak,
        value: "America/Adak",
        label: "America/Adak",
    },
    [TimeZoneEnum.America_Anchorage]: {
        key: TimeZoneEnum.America_Anchorage,
        value: "America/Anchorage",
        label: "America/Anchorage",
    },
    [TimeZoneEnum.America_Anguilla]: {
        key: TimeZoneEnum.America_Anguilla,
        value: "America/Anguilla",
        label: "America/Anguilla",
    },
    [TimeZoneEnum.America_Antigua]: {
        key: TimeZoneEnum.America_Antigua,
        value: "America/Antigua",
        label: "America/Antigua",
    },
    [TimeZoneEnum.America_Araguaina]: {
        key: TimeZoneEnum.America_Araguaina,
        value: "America/Araguaina",
        label: "America/Araguaina",
    },
    [TimeZoneEnum.America_Argentina_Buenos_Aires]: {
        key: TimeZoneEnum.America_Argentina_Buenos_Aires,
        value: "America/Argentina/Buenos_Aires",
        label: "America/Argentina/Buenos_Aires",
    },
    [TimeZoneEnum.America_Argentina_Catamarca]: {
        key: TimeZoneEnum.America_Argentina_Catamarca,
        value: "America/Argentina/Catamarca",
        label: "America/Argentina/Catamarca",
    },
    [TimeZoneEnum.America_Argentina_Cordoba]: {
        key: TimeZoneEnum.America_Argentina_Cordoba,
        value: "America/Argentina/Cordoba",
        label: "America/Argentina/Cordoba",
    },
    [TimeZoneEnum.America_Argentina_Jujuy]: {
        key: TimeZoneEnum.America_Argentina_Jujuy,
        value: "America/Argentina/Jujuy",
        label: "America/Argentina/Jujuy",
    },
    [TimeZoneEnum.America_Argentina_La_Rioja]: {
        key: TimeZoneEnum.America_Argentina_La_Rioja,
        value: "America/Argentina/La_Rioja",
        label: "America/Argentina/La_Rioja",
    },
    [TimeZoneEnum.America_Argentina_Mendoza]: {
        key: TimeZoneEnum.America_Argentina_Mendoza,
        value: "America/Argentina/Mendoza",
        label: "America/Argentina/Mendoza",
    },
    [TimeZoneEnum.America_Argentina_Rio_Gallegos]: {
        key: TimeZoneEnum.America_Argentina_Rio_Gallegos,
        value: "America/Argentina/Rio_Gallegos",
        label: "America/Argentina/Rio_Gallegos",
    },
    [TimeZoneEnum.America_Argentina_Salta]: {
        key: TimeZoneEnum.America_Argentina_Salta,
        value: "America/Argentina/Salta",
        label: "America/Argentina/Salta",
    },
    [TimeZoneEnum.America_Argentina_San_Juan]: {
        key: TimeZoneEnum.America_Argentina_San_Juan,
        value: "America/Argentina/San_Juan",
        label: "America/Argentina/San_Juan",
    },
    [TimeZoneEnum.America_Argentina_San_Luis]: {
        key: TimeZoneEnum.America_Argentina_San_Luis,
        value: "America/Argentina/San_Luis",
        label: "America/Argentina/San_Luis",
    },
    [TimeZoneEnum.America_Argentina_Tucuman]: {
        key: TimeZoneEnum.America_Argentina_Tucuman,
        value: "America/Argentina/Tucuman",
        label: "America/Argentina/Tucuman",
    },
    [TimeZoneEnum.America_Argentina_Ushuaia]: {
        key: TimeZoneEnum.America_Argentina_Ushuaia,
        value: "America/Argentina/Ushuaia",
        label: "America/Argentina/Ushuaia",
    },
    [TimeZoneEnum.America_Aruba]: {
        key: TimeZoneEnum.America_Aruba,
        value: "America/Aruba",
        label: "America/Aruba",
    },
    [TimeZoneEnum.America_Asuncion]: {
        key: TimeZoneEnum.America_Asuncion,
        value: "America/Asuncion",
        label: "America/Asuncion",
    },
    [TimeZoneEnum.America_Atikokan]: {
        key: TimeZoneEnum.America_Atikokan,
        value: "America/Atikokan",
        label: "America/Atikokan",
    },
    [TimeZoneEnum.America_Bahia]: {
        key: TimeZoneEnum.America_Bahia,
        value: "America/Bahia",
        label: "America/Bahia",
    },
    [TimeZoneEnum.America_Bahia_Banderas]: {
        key: TimeZoneEnum.America_Bahia_Banderas,
        value: "America/Bahia_Banderas",
        label: "America/Bahia_Banderas",
    },
    [TimeZoneEnum.America_Barbados]: {
        key: TimeZoneEnum.America_Barbados,
        value: "America/Barbados",
        label: "America/Barbados",
    },
    [TimeZoneEnum.America_Belem]: {
        key: TimeZoneEnum.America_Belem,
        value: "America/Belem",
        label: "America/Belem",
    },
    [TimeZoneEnum.America_Belize]: {
        key: TimeZoneEnum.America_Belize,
        value: "America/Belize",
        label: "America/Belize",
    },
    [TimeZoneEnum.America_Blanc_Sablon]: {
        key: TimeZoneEnum.America_Blanc_Sablon,
        value: "America/Blanc-Sablon",
        label: "America/Blanc-Sablon",
    },
    [TimeZoneEnum.America_Boa_Vista]: {
        key: TimeZoneEnum.America_Boa_Vista,
        value: "America/Boa_Vista",
        label: "America/Boa_Vista",
    },
    [TimeZoneEnum.America_Bogota]: {
        key: TimeZoneEnum.America_Bogota,
        value: "America/Bogota",
        label: "America/Bogota",
    },
    [TimeZoneEnum.America_Boise]: {
        key: TimeZoneEnum.America_Boise,
        value: "America/Boise",
        label: "America/Boise",
    },
    [TimeZoneEnum.America_Cambridge_Bay]: {
        key: TimeZoneEnum.America_Cambridge_Bay,
        value: "America/Cambridge_Bay",
        label: "America/Cambridge_Bay",
    },
    [TimeZoneEnum.America_Campo_Grande]: {
        key: TimeZoneEnum.America_Campo_Grande,
        value: "America/Campo_Grande",
        label: "America/Campo_Grande",
    },
    [TimeZoneEnum.America_Cancun]: {
        key: TimeZoneEnum.America_Cancun,
        value: "America/Cancun",
        label: "America/Cancun",
    },
    [TimeZoneEnum.America_Caracas]: {
        key: TimeZoneEnum.America_Caracas,
        value: "America/Caracas",
        label: "America/Caracas",
    },
    [TimeZoneEnum.America_Cayenne]: {
        key: TimeZoneEnum.America_Cayenne,
        value: "America/Cayenne",
        label: "America/Cayenne",
    },
    [TimeZoneEnum.America_Cayman]: {
        key: TimeZoneEnum.America_Cayman,
        value: "America/Cayman",
        label: "America/Cayman",
    },
    [TimeZoneEnum.America_Chicago]: {
        key: TimeZoneEnum.America_Chicago,
        value: "America/Chicago",
        label: "America/Chicago",
    },
    [TimeZoneEnum.America_Chihuahua]: {
        key: TimeZoneEnum.America_Chihuahua,
        value: "America/Chihuahua",
        label: "America/Chihuahua",
    },
    [TimeZoneEnum.America_Ciudad_Juarez]: {
        key: TimeZoneEnum.America_Ciudad_Juarez,
        value: "America/Ciudad_Juarez",
        label: "America/Ciudad_Juarez",
    },
    [TimeZoneEnum.America_Costa_Rica]: {
        key: TimeZoneEnum.America_Costa_Rica,
        value: "America/Costa_Rica",
        label: "America/Costa_Rica",
    },
    [TimeZoneEnum.America_Creston]: {
        key: TimeZoneEnum.America_Creston,
        value: "America/Creston",
        label: "America/Creston",
    },
    [TimeZoneEnum.America_Cuiaba]: {
        key: TimeZoneEnum.America_Cuiaba,
        value: "America/Cuiaba",
        label: "America/Cuiaba",
    },
    [TimeZoneEnum.America_Curacao]: {
        key: TimeZoneEnum.America_Curacao,
        value: "America/Curacao",
        label: "America/Curacao",
    },
    [TimeZoneEnum.America_Danmarkshavn]: {
        key: TimeZoneEnum.America_Danmarkshavn,
        value: "America/Danmarkshavn",
        label: "America/Danmarkshavn",
    },
    [TimeZoneEnum.America_Dawson]: {
        key: TimeZoneEnum.America_Dawson,
        value: "America/Dawson",
        label: "America/Dawson",
    },
    [TimeZoneEnum.America_Dawson_Creek]: {
        key: TimeZoneEnum.America_Dawson_Creek,
        value: "America/Dawson_Creek",
        label: "America/Dawson_Creek",
    },
    [TimeZoneEnum.America_Denver]: {
        key: TimeZoneEnum.America_Denver,
        value: "America/Denver",
        label: "America/Denver",
    },
    [TimeZoneEnum.America_Detroit]: {
        key: TimeZoneEnum.America_Detroit,
        value: "America/Detroit",
        label: "America/Detroit",
    },
    [TimeZoneEnum.America_Dominica]: {
        key: TimeZoneEnum.America_Dominica,
        value: "America/Dominica",
        label: "America/Dominica",
    },
    [TimeZoneEnum.America_Edmonton]: {
        key: TimeZoneEnum.America_Edmonton,
        value: "America/Edmonton",
        label: "America/Edmonton",
    },
    [TimeZoneEnum.America_Eirunepe]: {
        key: TimeZoneEnum.America_Eirunepe,
        value: "America/Eirunepe",
        label: "America/Eirunepe",
    },
    [TimeZoneEnum.America_El_Salvador]: {
        key: TimeZoneEnum.America_El_Salvador,
        value: "America/El_Salvador",
        label: "America/El_Salvador",
    },
    [TimeZoneEnum.America_Fort_Nelson]: {
        key: TimeZoneEnum.America_Fort_Nelson,
        value: "America/Fort_Nelson",
        label: "America/Fort_Nelson",
    },
    [TimeZoneEnum.America_Fortaleza]: {
        key: TimeZoneEnum.America_Fortaleza,
        value: "America/Fortaleza",
        label: "America/Fortaleza",
    },
    [TimeZoneEnum.America_Glace_Bay]: {
        key: TimeZoneEnum.America_Glace_Bay,
        value: "America/Glace_Bay",
        label: "America/Glace_Bay",
    },
    [TimeZoneEnum.America_Goose_Bay]: {
        key: TimeZoneEnum.America_Goose_Bay,
        value: "America/Goose_Bay",
        label: "America/Goose_Bay",
    },
    [TimeZoneEnum.America_Grand_Turk]: {
        key: TimeZoneEnum.America_Grand_Turk,
        value: "America/Grand_Turk",
        label: "America/Grand_Turk",
    },
    [TimeZoneEnum.America_Grenada]: {
        key: TimeZoneEnum.America_Grenada,
        value: "America/Grenada",
        label: "America/Grenada",
    },
    [TimeZoneEnum.America_Guadeloupe]: {
        key: TimeZoneEnum.America_Guadeloupe,
        value: "America/Guadeloupe",
        label: "America/Guadeloupe",
    },
    [TimeZoneEnum.America_Guatemala]: {
        key: TimeZoneEnum.America_Guatemala,
        value: "America/Guatemala",
        label: "America/Guatemala",
    },
    [TimeZoneEnum.America_Guayaquil]: {
        key: TimeZoneEnum.America_Guayaquil,
        value: "America/Guayaquil",
        label: "America/Guayaquil",
    },
    [TimeZoneEnum.America_Guyana]: {
        key: TimeZoneEnum.America_Guyana,
        value: "America/Guyana",
        label: "America/Guyana",
    },
    [TimeZoneEnum.America_Halifax]: {
        key: TimeZoneEnum.America_Halifax,
        value: "America/Halifax",
        label: "America/Halifax",
    },
    [TimeZoneEnum.America_Havana]: {
        key: TimeZoneEnum.America_Havana,
        value: "America/Havana",
        label: "America/Havana",
    },
    [TimeZoneEnum.America_Hermosillo]: {
        key: TimeZoneEnum.America_Hermosillo,
        value: "America/Hermosillo",
        label: "America/Hermosillo",
    },
    [TimeZoneEnum.America_Indiana_Indianapolis]: {
        key: TimeZoneEnum.America_Indiana_Indianapolis,
        value: "America/Indiana/Indianapolis",
        label: "America/Indiana/Indianapolis",
    },
    [TimeZoneEnum.America_Indiana_Knox]: {
        key: TimeZoneEnum.America_Indiana_Knox,
        value: "America/Indiana/Knox",
        label: "America/Indiana/Knox",
    },
    [TimeZoneEnum.America_Indiana_Marengo]: {
        key: TimeZoneEnum.America_Indiana_Marengo,
        value: "America/Indiana/Marengo",
        label: "America/Indiana/Marengo",
    },
    [TimeZoneEnum.America_Indiana_Petersburg]: {
        key: TimeZoneEnum.America_Indiana_Petersburg,
        value: "America/Indiana/Petersburg",
        label: "America/Indiana/Petersburg",
    },
    [TimeZoneEnum.America_Indiana_Tell_City]: {
        key: TimeZoneEnum.America_Indiana_Tell_City,
        value: "America/Indiana/Tell_City",
        label: "America/Indiana/Tell_City",
    },
    [TimeZoneEnum.America_Indiana_Vevay]: {
        key: TimeZoneEnum.America_Indiana_Vevay,
        value: "America/Indiana/Vevay",
        label: "America/Indiana/Vevay",
    },
    [TimeZoneEnum.America_Indiana_Vincennes]: {
        key: TimeZoneEnum.America_Indiana_Vincennes,
        value: "America/Indiana/Vincennes",
        label: "America/Indiana/Vincennes",
    },
    [TimeZoneEnum.America_Indiana_Winamac]: {
        key: TimeZoneEnum.America_Indiana_Winamac,
        value: "America/Indiana/Winamac",
        label: "America/Indiana/Winamac",
    },
    [TimeZoneEnum.America_Inuvik]: {
        key: TimeZoneEnum.America_Inuvik,
        value: "America/Inuvik",
        label: "America/Inuvik",
    },
    [TimeZoneEnum.America_Iqaluit]: {
        key: TimeZoneEnum.America_Iqaluit,
        value: "America/Iqaluit",
        label: "America/Iqaluit",
    },
    [TimeZoneEnum.America_Jamaica]: {
        key: TimeZoneEnum.America_Jamaica,
        value: "America/Jamaica",
        label: "America/Jamaica",
    },
    [TimeZoneEnum.America_Juneau]: {
        key: TimeZoneEnum.America_Juneau,
        value: "America/Juneau",
        label: "America/Juneau",
    },
    [TimeZoneEnum.America_Kentucky_Louisville]: {
        key: TimeZoneEnum.America_Kentucky_Louisville,
        value: "America/Kentucky/Louisville",
        label: "America/Kentucky/Louisville",
    },
    [TimeZoneEnum.America_Kentucky_Monticello]: {
        key: TimeZoneEnum.America_Kentucky_Monticello,
        value: "America/Kentucky/Monticello",
        label: "America/Kentucky/Monticello",
    },
    [TimeZoneEnum.America_Kralendijk]: {
        key: TimeZoneEnum.America_Kralendijk,
        value: "America/Kralendijk",
        label: "America/Kralendijk",
    },
    [TimeZoneEnum.America_La_Paz]: {
        key: TimeZoneEnum.America_La_Paz,
        value: "America/La_Paz",
        label: "America/La_Paz",
    },
    [TimeZoneEnum.America_Lima]: {
        key: TimeZoneEnum.America_Lima,
        value: "America/Lima",
        label: "America/Lima",
    },
    [TimeZoneEnum.America_Los_Angeles]: {
        key: TimeZoneEnum.America_Los_Angeles,
        value: "America/Los_Angeles",
        label: "America/Los_Angeles",
    },
    [TimeZoneEnum.America_Lower_Princes]: {
        key: TimeZoneEnum.America_Lower_Princes,
        value: "America/Lower_Princes",
        label: "America/Lower_Princes",
    },
    [TimeZoneEnum.America_Maceio]: {
        key: TimeZoneEnum.America_Maceio,
        value: "America/Maceio",
        label: "America/Maceio",
    },
    [TimeZoneEnum.America_Managua]: {
        key: TimeZoneEnum.America_Managua,
        value: "America/Managua",
        label: "America/Managua",
    },
    [TimeZoneEnum.America_Manaus]: {
        key: TimeZoneEnum.America_Manaus,
        value: "America/Manaus",
        label: "America/Manaus",
    },
    [TimeZoneEnum.America_Marigot]: {
        key: TimeZoneEnum.America_Marigot,
        value: "America/Marigot",
        label: "America/Marigot",
    },
    [TimeZoneEnum.America_Martinique]: {
        key: TimeZoneEnum.America_Martinique,
        value: "America/Martinique",
        label: "America/Martinique",
    },
    [TimeZoneEnum.America_Matamoros]: {
        key: TimeZoneEnum.America_Matamoros,
        value: "America/Matamoros",
        label: "America/Matamoros",
    },
    [TimeZoneEnum.America_Mazatlan]: {
        key: TimeZoneEnum.America_Mazatlan,
        value: "America/Mazatlan",
        label: "America/Mazatlan",
    },
    [TimeZoneEnum.America_Menominee]: {
        key: TimeZoneEnum.America_Menominee,
        value: "America/Menominee",
        label: "America/Menominee",
    },
    [TimeZoneEnum.America_Merida]: {
        key: TimeZoneEnum.America_Merida,
        value: "America/Merida",
        label: "America/Merida",
    },
    [TimeZoneEnum.America_Metlakatla]: {
        key: TimeZoneEnum.America_Metlakatla,
        value: "America/Metlakatla",
        label: "America/Metlakatla",
    },
    [TimeZoneEnum.America_Mexico_City]: {
        key: TimeZoneEnum.America_Mexico_City,
        value: "America/Mexico_City",
        label: "America/Mexico_City",
    },
    [TimeZoneEnum.America_Miquelon]: {
        key: TimeZoneEnum.America_Miquelon,
        value: "America/Miquelon",
        label: "America/Miquelon",
    },
    [TimeZoneEnum.America_Moncton]: {
        key: TimeZoneEnum.America_Moncton,
        value: "America/Moncton",
        label: "America/Moncton",
    },
    [TimeZoneEnum.America_Monterrey]: {
        key: TimeZoneEnum.America_Monterrey,
        value: "America/Monterrey",
        label: "America/Monterrey",
    },
    [TimeZoneEnum.America_Montevideo]: {
        key: TimeZoneEnum.America_Montevideo,
        value: "America/Montevideo",
        label: "America/Montevideo",
    },
    [TimeZoneEnum.America_Montserrat]: {
        key: TimeZoneEnum.America_Montserrat,
        value: "America/Montserrat",
        label: "America/Montserrat",
    },
    [TimeZoneEnum.America_Nassau]: {
        key: TimeZoneEnum.America_Nassau,
        value: "America/Nassau",
        label: "America/Nassau",
    },
    [TimeZoneEnum.America_New_York]: {
        key: TimeZoneEnum.America_New_York,
        value: "America/New_York",
        label: "America/New_York",
    },
    [TimeZoneEnum.America_Nome]: {
        key: TimeZoneEnum.America_Nome,
        value: "America/Nome",
        label: "America/Nome",
    },
    [TimeZoneEnum.America_Noronha]: {
        key: TimeZoneEnum.America_Noronha,
        value: "America/Noronha",
        label: "America/Noronha",
    },
    [TimeZoneEnum.America_North_Dakota_Beulah]: {
        key: TimeZoneEnum.America_North_Dakota_Beulah,
        value: "America/North_Dakota/Beulah",
        label: "America/North_Dakota/Beulah",
    },
    [TimeZoneEnum.America_North_Dakota_Center]: {
        key: TimeZoneEnum.America_North_Dakota_Center,
        value: "America/North_Dakota/Center",
        label: "America/North_Dakota/Center",
    },
    [TimeZoneEnum.America_North_Dakota_New_Salem]: {
        key: TimeZoneEnum.America_North_Dakota_New_Salem,
        value: "America/North_Dakota/New_Salem",
        label: "America/North_Dakota/New_Salem",
    },
    [TimeZoneEnum.America_Nuuk]: {
        key: TimeZoneEnum.America_Nuuk,
        value: "America/Nuuk",
        label: "America/Nuuk",
    },
    [TimeZoneEnum.America_Ojinaga]: {
        key: TimeZoneEnum.America_Ojinaga,
        value: "America/Ojinaga",
        label: "America/Ojinaga",
    },
    [TimeZoneEnum.America_Panama]: {
        key: TimeZoneEnum.America_Panama,
        value: "America/Panama",
        label: "America/Panama",
    },
    [TimeZoneEnum.America_Paramaribo]: {
        key: TimeZoneEnum.America_Paramaribo,
        value: "America/Paramaribo",
        label: "America/Paramaribo",
    },
    [TimeZoneEnum.America_Phoenix]: {
        key: TimeZoneEnum.America_Phoenix,
        value: "America/Phoenix",
        label: "America/Phoenix",
    },
    [TimeZoneEnum.America_Port_au_Prince]: {
        key: TimeZoneEnum.America_Port_au_Prince,
        value: "America/Port-au-Prince",
        label: "America/Port-au-Prince",
    },
    [TimeZoneEnum.America_Port_of_Spain]: {
        key: TimeZoneEnum.America_Port_of_Spain,
        value: "America/Port_of_Spain",
        label: "America/Port_of_Spain",
    },
    [TimeZoneEnum.America_Porto_Velho]: {
        key: TimeZoneEnum.America_Porto_Velho,
        value: "America/Porto_Velho",
        label: "America/Porto_Velho",
    },
    [TimeZoneEnum.America_Puerto_Rico]: {
        key: TimeZoneEnum.America_Puerto_Rico,
        value: "America/Puerto_Rico",
        label: "America/Puerto_Rico",
    },
    [TimeZoneEnum.America_Punta_Arenas]: {
        key: TimeZoneEnum.America_Punta_Arenas,
        value: "America/Punta_Arenas",
        label: "America/Punta_Arenas",
    },
    [TimeZoneEnum.America_Rankin_Inlet]: {
        key: TimeZoneEnum.America_Rankin_Inlet,
        value: "America/Rankin_Inlet",
        label: "America/Rankin_Inlet",
    },
    [TimeZoneEnum.America_Recife]: {
        key: TimeZoneEnum.America_Recife,
        value: "America/Recife",
        label: "America/Recife",
    },
    [TimeZoneEnum.America_Regina]: {
        key: TimeZoneEnum.America_Regina,
        value: "America/Regina",
        label: "America/Regina",
    },
    [TimeZoneEnum.America_Resolute]: {
        key: TimeZoneEnum.America_Resolute,
        value: "America/Resolute",
        label: "America/Resolute",
    },
    [TimeZoneEnum.America_Rio_Branco]: {
        key: TimeZoneEnum.America_Rio_Branco,
        value: "America/Rio_Branco",
        label: "America/Rio_Branco",
    },
    [TimeZoneEnum.America_Santarem]: {
        key: TimeZoneEnum.America_Santarem,
        value: "America/Santarem",
        label: "America/Santarem",
    },
    [TimeZoneEnum.America_Santiago]: {
        key: TimeZoneEnum.America_Santiago,
        value: "America/Santiago",
        label: "America/Santiago",
    },
    [TimeZoneEnum.America_Santo_Domingo]: {
        key: TimeZoneEnum.America_Santo_Domingo,
        value: "America/Santo_Domingo",
        label: "America/Santo_Domingo",
    },
    [TimeZoneEnum.America_Sao_Paulo]: {
        key: TimeZoneEnum.America_Sao_Paulo,
        value: "America/Sao_Paulo",
        label: "America/Sao_Paulo",
    },
    [TimeZoneEnum.America_Scoresbysund]: {
        key: TimeZoneEnum.America_Scoresbysund,
        value: "America/Scoresbysund",
        label: "America/Scoresbysund",
    },
    [TimeZoneEnum.America_Sitka]: {
        key: TimeZoneEnum.America_Sitka,
        value: "America/Sitka",
        label: "America/Sitka",
    },
    [TimeZoneEnum.America_St_Barthelemy]: {
        key: TimeZoneEnum.America_St_Barthelemy,
        value: "America/St_Barthelemy",
        label: "America/St_Barthelemy",
    },
    [TimeZoneEnum.America_St_Johns]: {
        key: TimeZoneEnum.America_St_Johns,
        value: "America/St_Johns",
        label: "America/St_Johns",
    },
    [TimeZoneEnum.America_St_Kitts]: {
        key: TimeZoneEnum.America_St_Kitts,
        value: "America/St_Kitts",
        label: "America/St_Kitts",
    },
    [TimeZoneEnum.America_St_Lucia]: {
        key: TimeZoneEnum.America_St_Lucia,
        value: "America/St_Lucia",
        label: "America/St_Lucia",
    },
    [TimeZoneEnum.America_St_Thomas]: {
        key: TimeZoneEnum.America_St_Thomas,
        value: "America/St_Thomas",
        label: "America/St_Thomas",
    },
    [TimeZoneEnum.America_St_Vincent]: {
        key: TimeZoneEnum.America_St_Vincent,
        value: "America/St_Vincent",
        label: "America/St_Vincent",
    },
    [TimeZoneEnum.America_Swift_Current]: {
        key: TimeZoneEnum.America_Swift_Current,
        value: "America/Swift_Current",
        label: "America/Swift_Current",
    },
    [TimeZoneEnum.America_Tegucigalpa]: {
        key: TimeZoneEnum.America_Tegucigalpa,
        value: "America/Tegucigalpa",
        label: "America/Tegucigalpa",
    },
    [TimeZoneEnum.America_Thule]: {
        key: TimeZoneEnum.America_Thule,
        value: "America/Thule",
        label: "America/Thule",
    },
    [TimeZoneEnum.America_Tijuana]: {
        key: TimeZoneEnum.America_Tijuana,
        value: "America/Tijuana",
        label: "America/Tijuana",
    },
    [TimeZoneEnum.America_Toronto]: {
        key: TimeZoneEnum.America_Toronto,
        value: "America/Toronto",
        label: "America/Toronto",
    },
    [TimeZoneEnum.America_Tortola]: {
        key: TimeZoneEnum.America_Tortola,
        value: "America/Tortola",
        label: "America/Tortola",
    },
    [TimeZoneEnum.America_Vancouver]: {
        key: TimeZoneEnum.America_Vancouver,
        value: "America/Vancouver",
        label: "America/Vancouver",
    },
    [TimeZoneEnum.America_Whitehorse]: {
        key: TimeZoneEnum.America_Whitehorse,
        value: "America/Whitehorse",
        label: "America/Whitehorse",
    },
    [TimeZoneEnum.America_Winnipeg]: {
        key: TimeZoneEnum.America_Winnipeg,
        value: "America/Winnipeg",
        label: "America/Winnipeg",
    },
    [TimeZoneEnum.America_Yakutat]: {
        key: TimeZoneEnum.America_Yakutat,
        value: "America/Yakutat",
        label: "America/Yakutat",
    },
    [TimeZoneEnum.Antarctica_Casey]: {
        key: TimeZoneEnum.Antarctica_Casey,
        value: "Antarctica/Casey",
        label: "Antarctica/Casey",
    },
    [TimeZoneEnum.Antarctica_Davis]: {
        key: TimeZoneEnum.Antarctica_Davis,
        value: "Antarctica/Davis",
        label: "Antarctica/Davis",
    },
    [TimeZoneEnum.Antarctica_DumontDUrville]: {
        key: TimeZoneEnum.Antarctica_DumontDUrville,
        value: "Antarctica/DumontDUrville",
        label: "Antarctica/DumontDUrville",
    },
    [TimeZoneEnum.Antarctica_Macquarie]: {
        key: TimeZoneEnum.Antarctica_Macquarie,
        value: "Antarctica/Macquarie",
        label: "Antarctica/Macquarie",
    },
    [TimeZoneEnum.Antarctica_Mawson]: {
        key: TimeZoneEnum.Antarctica_Mawson,
        value: "Antarctica/Mawson",
        label: "Antarctica/Mawson",
    },
    [TimeZoneEnum.Antarctica_McMurdo]: {
        key: TimeZoneEnum.Antarctica_McMurdo,
        value: "Antarctica/McMurdo",
        label: "Antarctica/McMurdo",
    },
    [TimeZoneEnum.Antarctica_Palmer]: {
        key: TimeZoneEnum.Antarctica_Palmer,
        value: "Antarctica/Palmer",
        label: "Antarctica/Palmer",
    },
    [TimeZoneEnum.Antarctica_Rothera]: {
        key: TimeZoneEnum.Antarctica_Rothera,
        value: "Antarctica/Rothera",
        label: "Antarctica/Rothera",
    },
    [TimeZoneEnum.Antarctica_Syowa]: {
        key: TimeZoneEnum.Antarctica_Syowa,
        value: "Antarctica/Syowa",
        label: "Antarctica/Syowa",
    },
    [TimeZoneEnum.Antarctica_Troll]: {
        key: TimeZoneEnum.Antarctica_Troll,
        value: "Antarctica/Troll",
        label: "Antarctica/Troll",
    },
    [TimeZoneEnum.Antarctica_Vostok]: {
        key: TimeZoneEnum.Antarctica_Vostok,
        value: "Antarctica/Vostok",
        label: "Antarctica/Vostok",
    },
    [TimeZoneEnum.Arctic_Longyearbyen]: {
        key: TimeZoneEnum.Arctic_Longyearbyen,
        value: "Arctic/Longyearbyen",
        label: "Arctic/Longyearbyen",
    },
    [TimeZoneEnum.Asia_Aden]: {
        key: TimeZoneEnum.Asia_Aden,
        value: "Asia/Aden",
        label: "Asia/Aden",
    },
    [TimeZoneEnum.Asia_Almaty]: {
        key: TimeZoneEnum.Asia_Almaty,
        value: "Asia/Almaty",
        label: "Asia/Almaty",
    },
    [TimeZoneEnum.Asia_Amman]: {
        key: TimeZoneEnum.Asia_Amman,
        value: "Asia/Amman",
        label: "Asia/Amman",
    },
    [TimeZoneEnum.Asia_Anadyr]: {
        key: TimeZoneEnum.Asia_Anadyr,
        value: "Asia/Anadyr",
        label: "Asia/Anadyr",
    },
    [TimeZoneEnum.Asia_Aqtau]: {
        key: TimeZoneEnum.Asia_Aqtau,
        value: "Asia/Aqtau",
        label: "Asia/Aqtau",
    },
    [TimeZoneEnum.Asia_Aqtobe]: {
        key: TimeZoneEnum.Asia_Aqtobe,
        value: "Asia/Aqtobe",
        label: "Asia/Aqtobe",
    },
    [TimeZoneEnum.Asia_Ashgabat]: {
        key: TimeZoneEnum.Asia_Ashgabat,
        value: "Asia/Ashgabat",
        label: "Asia/Ashgabat",
    },
    [TimeZoneEnum.Asia_Atyrau]: {
        key: TimeZoneEnum.Asia_Atyrau,
        value: "Asia/Atyrau",
        label: "Asia/Atyrau",
    },
    [TimeZoneEnum.Asia_Baghdad]: {
        key: TimeZoneEnum.Asia_Baghdad,
        value: "Asia/Baghdad",
        label: "Asia/Baghdad",
    },
    [TimeZoneEnum.Asia_Bahrain]: {
        key: TimeZoneEnum.Asia_Bahrain,
        value: "Asia/Bahrain",
        label: "Asia/Bahrain",
    },
    [TimeZoneEnum.Asia_Baku]: {
        key: TimeZoneEnum.Asia_Baku,
        value: "Asia/Baku",
        label: "Asia/Baku",
    },
    [TimeZoneEnum.Asia_Bangkok]: {
        key: TimeZoneEnum.Asia_Bangkok,
        value: "Asia/Bangkok",
        label: "Asia/Bangkok",
    },
    [TimeZoneEnum.Asia_Barnaul]: {
        key: TimeZoneEnum.Asia_Barnaul,
        value: "Asia/Barnaul",
        label: "Asia/Barnaul",
    },
    [TimeZoneEnum.Asia_Beirut]: {
        key: TimeZoneEnum.Asia_Beirut,
        value: "Asia/Beirut",
        label: "Asia/Beirut",
    },
    [TimeZoneEnum.Asia_Bishkek]: {
        key: TimeZoneEnum.Asia_Bishkek,
        value: "Asia/Bishkek",
        label: "Asia/Bishkek",
    },
    [TimeZoneEnum.Asia_Brunei]: {
        key: TimeZoneEnum.Asia_Brunei,
        value: "Asia/Brunei",
        label: "Asia/Brunei",
    },
    [TimeZoneEnum.Asia_Chita]: {
        key: TimeZoneEnum.Asia_Chita,
        value: "Asia/Chita",
        label: "Asia/Chita",
    },
    [TimeZoneEnum.Asia_Colombo]: {
        key: TimeZoneEnum.Asia_Colombo,
        value: "Asia/Colombo",
        label: "Asia/Colombo",
    },
    [TimeZoneEnum.Asia_Damascus]: {
        key: TimeZoneEnum.Asia_Damascus,
        value: "Asia/Damascus",
        label: "Asia/Damascus",
    },
    [TimeZoneEnum.Asia_Dhaka]: {
        key: TimeZoneEnum.Asia_Dhaka,
        value: "Asia/Dhaka",
        label: "Asia/Dhaka",
    },
    [TimeZoneEnum.Asia_Dili]: {
        key: TimeZoneEnum.Asia_Dili,
        value: "Asia/Dili",
        label: "Asia/Dili",
    },
    [TimeZoneEnum.Asia_Dubai]: {
        key: TimeZoneEnum.Asia_Dubai,
        value: "Asia/Dubai",
        label: "Asia/Dubai",
    },
    [TimeZoneEnum.Asia_Dushanbe]: {
        key: TimeZoneEnum.Asia_Dushanbe,
        value: "Asia/Dushanbe",
        label: "Asia/Dushanbe",
    },
    [TimeZoneEnum.Asia_Famagusta]: {
        key: TimeZoneEnum.Asia_Famagusta,
        value: "Asia/Famagusta",
        label: "Asia/Famagusta",
    },
    [TimeZoneEnum.Asia_Gaza]: {
        key: TimeZoneEnum.Asia_Gaza,
        value: "Asia/Gaza",
        label: "Asia/Gaza",
    },
    [TimeZoneEnum.Asia_Hebron]: {
        key: TimeZoneEnum.Asia_Hebron,
        value: "Asia/Hebron",
        label: "Asia/Hebron",
    },
    [TimeZoneEnum.Asia_Ho_Chi_Minh]: {
        key: TimeZoneEnum.Asia_Ho_Chi_Minh,
        value: "Asia/Ho_Chi_Minh",
        label: "Asia/Ho_Chi_Minh",
    },
    [TimeZoneEnum.Asia_Hong_Kong]: {
        key: TimeZoneEnum.Asia_Hong_Kong,
        value: "Asia/Hong_Kong",
        label: "Asia/Hong_Kong",
    },
    [TimeZoneEnum.Asia_Hovd]: {
        key: TimeZoneEnum.Asia_Hovd,
        value: "Asia/Hovd",
        label: "Asia/Hovd",
    },
    [TimeZoneEnum.Asia_Irkutsk]: {
        key: TimeZoneEnum.Asia_Irkutsk,
        value: "Asia/Irkutsk",
        label: "Asia/Irkutsk",
    },
    [TimeZoneEnum.Asia_Jakarta]: {
        key: TimeZoneEnum.Asia_Jakarta,
        value: "Asia/Jakarta",
        label: "Asia/Jakarta",
    },
    [TimeZoneEnum.Asia_Jayapura]: {
        key: TimeZoneEnum.Asia_Jayapura,
        value: "Asia/Jayapura",
        label: "Asia/Jayapura",
    },
    [TimeZoneEnum.Asia_Jerusalem]: {
        key: TimeZoneEnum.Asia_Jerusalem,
        value: "Asia/Jerusalem",
        label: "Asia/Jerusalem",
    },
    [TimeZoneEnum.Asia_Kabul]: {
        key: TimeZoneEnum.Asia_Kabul,
        value: "Asia/Kabul",
        label: "Asia/Kabul",
    },
    [TimeZoneEnum.Asia_Kamchatka]: {
        key: TimeZoneEnum.Asia_Kamchatka,
        value: "Asia/Kamchatka",
        label: "Asia/Kamchatka",
    },
    [TimeZoneEnum.Asia_Karachi]: {
        key: TimeZoneEnum.Asia_Karachi,
        value: "Asia/Karachi",
        label: "Asia/Karachi",
    },
    [TimeZoneEnum.Asia_Kathmandu]: {
        key: TimeZoneEnum.Asia_Kathmandu,
        value: "Asia/Kathmandu",
        label: "Asia/Kathmandu",
    },
    [TimeZoneEnum.Asia_Khandyga]: {
        key: TimeZoneEnum.Asia_Khandyga,
        value: "Asia/Khandyga",
        label: "Asia/Khandyga",
    },
    [TimeZoneEnum.Asia_Kolkata]: {
        key: TimeZoneEnum.Asia_Kolkata,
        value: "Asia/Kolkata",
        label: "Asia/Kolkata",
    },
    [TimeZoneEnum.Asia_Krasnoyarsk]: {
        key: TimeZoneEnum.Asia_Krasnoyarsk,
        value: "Asia/Krasnoyarsk",
        label: "Asia/Krasnoyarsk",
    },
    [TimeZoneEnum.Asia_Kuala_Lumpur]: {
        key: TimeZoneEnum.Asia_Kuala_Lumpur,
        value: "Asia/Kuala_Lumpur",
        label: "Asia/Kuala_Lumpur",
    },
    [TimeZoneEnum.Asia_Kuching]: {
        key: TimeZoneEnum.Asia_Kuching,
        value: "Asia/Kuching",
        label: "Asia/Kuching",
    },
    [TimeZoneEnum.Asia_Kuwait]: {
        key: TimeZoneEnum.Asia_Kuwait,
        value: "Asia/Kuwait",
        label: "Asia/Kuwait",
    },
    [TimeZoneEnum.Asia_Macau]: {
        key: TimeZoneEnum.Asia_Macau,
        value: "Asia/Macau",
        label: "Asia/Macau",
    },
    [TimeZoneEnum.Asia_Magadan]: {
        key: TimeZoneEnum.Asia_Magadan,
        value: "Asia/Magadan",
        label: "Asia/Magadan",
    },
    [TimeZoneEnum.Asia_Makassar]: {
        key: TimeZoneEnum.Asia_Makassar,
        value: "Asia/Makassar",
        label: "Asia/Makassar",
    },
    [TimeZoneEnum.Asia_Manila]: {
        key: TimeZoneEnum.Asia_Manila,
        value: "Asia/Manila",
        label: "Asia/Manila",
    },
    [TimeZoneEnum.Asia_Muscat]: {
        key: TimeZoneEnum.Asia_Muscat,
        value: "Asia/Muscat",
        label: "Asia/Muscat",
    },
    [TimeZoneEnum.Asia_Nicosia]: {
        key: TimeZoneEnum.Asia_Nicosia,
        value: "Asia/Nicosia",
        label: "Asia/Nicosia",
    },
    [TimeZoneEnum.Asia_Novokuznetsk]: {
        key: TimeZoneEnum.Asia_Novokuznetsk,
        value: "Asia/Novokuznetsk",
        label: "Asia/Novokuznetsk",
    },
    [TimeZoneEnum.Asia_Novosibirsk]: {
        key: TimeZoneEnum.Asia_Novosibirsk,
        value: "Asia/Novosibirsk",
        label: "Asia/Novosibirsk",
    },
    [TimeZoneEnum.Asia_Omsk]: {
        key: TimeZoneEnum.Asia_Omsk,
        value: "Asia/Omsk",
        label: "Asia/Omsk",
    },
    [TimeZoneEnum.Asia_Oral]: {
        key: TimeZoneEnum.Asia_Oral,
        value: "Asia/Oral",
        label: "Asia/Oral",
    },
    [TimeZoneEnum.Asia_Phnom_Penh]: {
        key: TimeZoneEnum.Asia_Phnom_Penh,
        value: "Asia/Phnom_Penh",
        label: "Asia/Phnom_Penh",
    },
    [TimeZoneEnum.Asia_Pontianak]: {
        key: TimeZoneEnum.Asia_Pontianak,
        value: "Asia/Pontianak",
        label: "Asia/Pontianak",
    },
    [TimeZoneEnum.Asia_Pyongyang]: {
        key: TimeZoneEnum.Asia_Pyongyang,
        value: "Asia/Pyongyang",
        label: "Asia/Pyongyang",
    },
    [TimeZoneEnum.Asia_Qatar]: {
        key: TimeZoneEnum.Asia_Qatar,
        value: "Asia/Qatar",
        label: "Asia/Qatar",
    },
    [TimeZoneEnum.Asia_Qostanay]: {
        key: TimeZoneEnum.Asia_Qostanay,
        value: "Asia/Qostanay",
        label: "Asia/Qostanay",
    },
    [TimeZoneEnum.Asia_Qyzylorda]: {
        key: TimeZoneEnum.Asia_Qyzylorda,
        value: "Asia/Qyzylorda",
        label: "Asia/Qyzylorda",
    },
    [TimeZoneEnum.Asia_Riyadh]: {
        key: TimeZoneEnum.Asia_Riyadh,
        value: "Asia/Riyadh",
        label: "Asia/Riyadh",
    },
    [TimeZoneEnum.Asia_Sakhalin]: {
        key: TimeZoneEnum.Asia_Sakhalin,
        value: "Asia/Sakhalin",
        label: "Asia/Sakhalin",
    },
    [TimeZoneEnum.Asia_Samarkand]: {
        key: TimeZoneEnum.Asia_Samarkand,
        value: "Asia/Samarkand",
        label: "Asia/Samarkand",
    },
    [TimeZoneEnum.Asia_Seoul]: {
        key: TimeZoneEnum.Asia_Seoul,
        value: "Asia/Seoul",
        label: "Asia/Seoul",
    },
    [TimeZoneEnum.Asia_Shanghai]: {
        key: TimeZoneEnum.Asia_Shanghai,
        value: "Asia/Shanghai",
        label: "Asia/Shanghai",
    },
    [TimeZoneEnum.Asia_Singapore]: {
        key: TimeZoneEnum.Asia_Singapore,
        value: "Asia/Singapore",
        label: "Asia/Singapore",
    },
    [TimeZoneEnum.Asia_Srednekolymsk]: {
        key: TimeZoneEnum.Asia_Srednekolymsk,
        value: "Asia/Srednekolymsk",
        label: "Asia/Srednekolymsk",
    },
    [TimeZoneEnum.Asia_Taipei]: {
        key: TimeZoneEnum.Asia_Taipei,
        value: "Asia/Taipei",
        label: "Asia/Taipei",
    },
    [TimeZoneEnum.Asia_Tashkent]: {
        key: TimeZoneEnum.Asia_Tashkent,
        value: "Asia/Tashkent",
        label: "Asia/Tashkent",
    },
    [TimeZoneEnum.Asia_Tbilisi]: {
        key: TimeZoneEnum.Asia_Tbilisi,
        value: "Asia/Tbilisi",
        label: "Asia/Tbilisi",
    },
    [TimeZoneEnum.Asia_Tehran]: {
        key: TimeZoneEnum.Asia_Tehran,
        value: "Asia/Tehran",
        label: "Asia/Tehran",
    },
    [TimeZoneEnum.Asia_Thimphu]: {
        key: TimeZoneEnum.Asia_Thimphu,
        value: "Asia/Thimphu",
        label: "Asia/Thimphu",
    },
    [TimeZoneEnum.Asia_Tokyo]: {
        key: TimeZoneEnum.Asia_Tokyo,
        value: "Asia/Tokyo",
        label: "Asia/Tokyo",
    },
    [TimeZoneEnum.Asia_Tomsk]: {
        key: TimeZoneEnum.Asia_Tomsk,
        value: "Asia/Tomsk",
        label: "Asia/Tomsk",
    },
    [TimeZoneEnum.Asia_Ulaanbaatar]: {
        key: TimeZoneEnum.Asia_Ulaanbaatar,
        value: "Asia/Ulaanbaatar",
        label: "Asia/Ulaanbaatar",
    },
    [TimeZoneEnum.Asia_Urumqi]: {
        key: TimeZoneEnum.Asia_Urumqi,
        value: "Asia/Urumqi",
        label: "Asia/Urumqi",
    },
    [TimeZoneEnum.Asia_Ust_Nera]: {
        key: TimeZoneEnum.Asia_Ust_Nera,
        value: "Asia/Ust-Nera",
        label: "Asia/Ust-Nera",
    },
    [TimeZoneEnum.Asia_Vientiane]: {
        key: TimeZoneEnum.Asia_Vientiane,
        value: "Asia/Vientiane",
        label: "Asia/Vientiane",
    },
    [TimeZoneEnum.Asia_Vladivostok]: {
        key: TimeZoneEnum.Asia_Vladivostok,
        value: "Asia/Vladivostok",
        label: "Asia/Vladivostok",
    },
    [TimeZoneEnum.Asia_Yakutsk]: {
        key: TimeZoneEnum.Asia_Yakutsk,
        value: "Asia/Yakutsk",
        label: "Asia/Yakutsk",
    },
    [TimeZoneEnum.Asia_Yangon]: {
        key: TimeZoneEnum.Asia_Yangon,
        value: "Asia/Yangon",
        label: "Asia/Yangon",
    },
    [TimeZoneEnum.Asia_Yekaterinburg]: {
        key: TimeZoneEnum.Asia_Yekaterinburg,
        value: "Asia/Yekaterinburg",
        label: "Asia/Yekaterinburg",
    },
    [TimeZoneEnum.Asia_Yerevan]: {
        key: TimeZoneEnum.Asia_Yerevan,
        value: "Asia/Yerevan",
        label: "Asia/Yerevan",
    },
    [TimeZoneEnum.Atlantic_Azores]: {
        key: TimeZoneEnum.Atlantic_Azores,
        value: "Atlantic/Azores",
        label: "Atlantic/Azores",
    },
    [TimeZoneEnum.Atlantic_Bermuda]: {
        key: TimeZoneEnum.Atlantic_Bermuda,
        value: "Atlantic/Bermuda",
        label: "Atlantic/Bermuda",
    },
    [TimeZoneEnum.Atlantic_Canary]: {
        key: TimeZoneEnum.Atlantic_Canary,
        value: "Atlantic/Canary",
        label: "Atlantic/Canary",
    },
    [TimeZoneEnum.Atlantic_Cape_Verde]: {
        key: TimeZoneEnum.Atlantic_Cape_Verde,
        value: "Atlantic/Cape_Verde",
        label: "Atlantic/Cape_Verde",
    },
    [TimeZoneEnum.Atlantic_Faroe]: {
        key: TimeZoneEnum.Atlantic_Faroe,
        value: "Atlantic/Faroe",
        label: "Atlantic/Faroe",
    },
    [TimeZoneEnum.Atlantic_Madeira]: {
        key: TimeZoneEnum.Atlantic_Madeira,
        value: "Atlantic/Madeira",
        label: "Atlantic/Madeira",
    },
    [TimeZoneEnum.Atlantic_Reykjavik]: {
        key: TimeZoneEnum.Atlantic_Reykjavik,
        value: "Atlantic/Reykjavik",
        label: "Atlantic/Reykjavik",
    },
    [TimeZoneEnum.Atlantic_South_Georgia]: {
        key: TimeZoneEnum.Atlantic_South_Georgia,
        value: "Atlantic/South_Georgia",
        label: "Atlantic/South_Georgia",
    },
    [TimeZoneEnum.Atlantic_St_Helena]: {
        key: TimeZoneEnum.Atlantic_St_Helena,
        value: "Atlantic/St_Helena",
        label: "Atlantic/St_Helena",
    },
    [TimeZoneEnum.Atlantic_Stanley]: {
        key: TimeZoneEnum.Atlantic_Stanley,
        value: "Atlantic/Stanley",
        label: "Atlantic/Stanley",
    },
    [TimeZoneEnum.Australia_Adelaide]: {
        key: TimeZoneEnum.Australia_Adelaide,
        value: "Australia/Adelaide",
        label: "Australia/Adelaide",
    },
    [TimeZoneEnum.Australia_Brisbane]: {
        key: TimeZoneEnum.Australia_Brisbane,
        value: "Australia/Brisbane",
        label: "Australia/Brisbane",
    },
    [TimeZoneEnum.Australia_Broken_Hill]: {
        key: TimeZoneEnum.Australia_Broken_Hill,
        value: "Australia/Broken_Hill",
        label: "Australia/Broken_Hill",
    },
    [TimeZoneEnum.Australia_Darwin]: {
        key: TimeZoneEnum.Australia_Darwin,
        value: "Australia/Darwin",
        label: "Australia/Darwin",
    },
    [TimeZoneEnum.Australia_Eucla]: {
        key: TimeZoneEnum.Australia_Eucla,
        value: "Australia/Eucla",
        label: "Australia/Eucla",
    },
    [TimeZoneEnum.Australia_Hobart]: {
        key: TimeZoneEnum.Australia_Hobart,
        value: "Australia/Hobart",
        label: "Australia/Hobart",
    },
    [TimeZoneEnum.Australia_Lindeman]: {
        key: TimeZoneEnum.Australia_Lindeman,
        value: "Australia/Lindeman",
        label: "Australia/Lindeman",
    },
    [TimeZoneEnum.Australia_Lord_Howe]: {
        key: TimeZoneEnum.Australia_Lord_Howe,
        value: "Australia/Lord_Howe",
        label: "Australia/Lord_Howe",
    },
    [TimeZoneEnum.Australia_Melbourne]: {
        key: TimeZoneEnum.Australia_Melbourne,
        value: "Australia/Melbourne",
        label: "Australia/Melbourne",
    },
    [TimeZoneEnum.Australia_Perth]: {
        key: TimeZoneEnum.Australia_Perth,
        value: "Australia/Perth",
        label: "Australia/Perth",
    },
    [TimeZoneEnum.Australia_Sydney]: {
        key: TimeZoneEnum.Australia_Sydney,
        value: "Australia/Sydney",
        label: "Australia/Sydney",
    },
    [TimeZoneEnum.Europe_Amsterdam]: {
        key: TimeZoneEnum.Europe_Amsterdam,
        value: "Europe/Amsterdam",
        label: "Europe/Amsterdam",
    },
    [TimeZoneEnum.Europe_Andorra]: {
        key: TimeZoneEnum.Europe_Andorra,
        value: "Europe/Andorra",
        label: "Europe/Andorra",
    },
    [TimeZoneEnum.Europe_Astrakhan]: {
        key: TimeZoneEnum.Europe_Astrakhan,
        value: "Europe/Astrakhan",
        label: "Europe/Astrakhan",
    },
    [TimeZoneEnum.Europe_Athens]: {
        key: TimeZoneEnum.Europe_Athens,
        value: "Europe/Athens",
        label: "Europe/Athens",
    },
    [TimeZoneEnum.Europe_Belgrade]: {
        key: TimeZoneEnum.Europe_Belgrade,
        value: "Europe/Belgrade",
        label: "Europe/Belgrade",
    },
    [TimeZoneEnum.Europe_Berlin]: {
        key: TimeZoneEnum.Europe_Berlin,
        value: "Europe/Berlin",
        label: "Europe/Berlin",
    },
    [TimeZoneEnum.Europe_Bratislava]: {
        key: TimeZoneEnum.Europe_Bratislava,
        value: "Europe/Bratislava",
        label: "Europe/Bratislava",
    },
    [TimeZoneEnum.Europe_Brussels]: {
        key: TimeZoneEnum.Europe_Brussels,
        value: "Europe/Brussels",
        label: "Europe/Brussels",
    },
    [TimeZoneEnum.Europe_Bucharest]: {
        key: TimeZoneEnum.Europe_Bucharest,
        value: "Europe/Bucharest",
        label: "Europe/Bucharest",
    },
    [TimeZoneEnum.Europe_Budapest]: {
        key: TimeZoneEnum.Europe_Budapest,
        value: "Europe/Budapest",
        label: "Europe/Budapest",
    },
    [TimeZoneEnum.Europe_Busingen]: {
        key: TimeZoneEnum.Europe_Busingen,
        value: "Europe/Busingen",
        label: "Europe/Busingen",
    },
    [TimeZoneEnum.Europe_Chisinau]: {
        key: TimeZoneEnum.Europe_Chisinau,
        value: "Europe/Chisinau",
        label: "Europe/Chisinau",
    },
    [TimeZoneEnum.Europe_Copenhagen]: {
        key: TimeZoneEnum.Europe_Copenhagen,
        value: "Europe/Copenhagen",
        label: "Europe/Copenhagen",
    },
    [TimeZoneEnum.Europe_Dublin]: {
        key: TimeZoneEnum.Europe_Dublin,
        value: "Europe/Dublin",
        label: "Europe/Dublin",
    },
    [TimeZoneEnum.Europe_Gibraltar]: {
        key: TimeZoneEnum.Europe_Gibraltar,
        value: "Europe/Gibraltar",
        label: "Europe/Gibraltar",
    },
    [TimeZoneEnum.Europe_Guernsey]: {
        key: TimeZoneEnum.Europe_Guernsey,
        value: "Europe/Guernsey",
        label: "Europe/Guernsey",
    },
    [TimeZoneEnum.Europe_Helsinki]: {
        key: TimeZoneEnum.Europe_Helsinki,
        value: "Europe/Helsinki",
        label: "Europe/Helsinki",
    },
    [TimeZoneEnum.Europe_Isle_of_Man]: {
        key: TimeZoneEnum.Europe_Isle_of_Man,
        value: "Europe/Isle_of_Man",
        label: "Europe/Isle_of_Man",
    },
    [TimeZoneEnum.Europe_Istanbul]: {
        key: TimeZoneEnum.Europe_Istanbul,
        value: "Europe/Istanbul",
        label: "Europe/Istanbul",
    },
    [TimeZoneEnum.Europe_Jersey]: {
        key: TimeZoneEnum.Europe_Jersey,
        value: "Europe/Jersey",
        label: "Europe/Jersey",
    },
    [TimeZoneEnum.Europe_Kaliningrad]: {
        key: TimeZoneEnum.Europe_Kaliningrad,
        value: "Europe/Kaliningrad",
        label: "Europe/Kaliningrad",
    },
    [TimeZoneEnum.Europe_Kirov]: {
        key: TimeZoneEnum.Europe_Kirov,
        value: "Europe/Kirov",
        label: "Europe/Kirov",
    },
    [TimeZoneEnum.Europe_Kyiv]: {
        key: TimeZoneEnum.Europe_Kyiv,
        value: "Europe/Kyiv",
        label: "Europe/Kyiv",
    },
    [TimeZoneEnum.Europe_Lisbon]: {
        key: TimeZoneEnum.Europe_Lisbon,
        value: "Europe/Lisbon",
        label: "Europe/Lisbon",
    },
    [TimeZoneEnum.Europe_Ljubljana]: {
        key: TimeZoneEnum.Europe_Ljubljana,
        value: "Europe/Ljubljana",
        label: "Europe/Ljubljana",
    },
    [TimeZoneEnum.Europe_London]: {
        key: TimeZoneEnum.Europe_London,
        value: "Europe/London",
        label: "Europe/London",
    },
    [TimeZoneEnum.Europe_Luxembourg]: {
        key: TimeZoneEnum.Europe_Luxembourg,
        value: "Europe/Luxembourg",
        label: "Europe/Luxembourg",
    },
    [TimeZoneEnum.Europe_Madrid]: {
        key: TimeZoneEnum.Europe_Madrid,
        value: "Europe/Madrid",
        label: "Europe/Madrid",
    },
    [TimeZoneEnum.Europe_Malta]: {
        key: TimeZoneEnum.Europe_Malta,
        value: "Europe/Malta",
        label: "Europe/Malta",
    },
    [TimeZoneEnum.Europe_Mariehamn]: {
        key: TimeZoneEnum.Europe_Mariehamn,
        value: "Europe/Mariehamn",
        label: "Europe/Mariehamn",
    },
    [TimeZoneEnum.Europe_Minsk]: {
        key: TimeZoneEnum.Europe_Minsk,
        value: "Europe/Minsk",
        label: "Europe/Minsk",
    },
    [TimeZoneEnum.Europe_Monaco]: {
        key: TimeZoneEnum.Europe_Monaco,
        value: "Europe/Monaco",
        label: "Europe/Monaco",
    },
    [TimeZoneEnum.Europe_Moscow]: {
        key: TimeZoneEnum.Europe_Moscow,
        value: "Europe/Moscow",
        label: "Europe/Moscow",
    },
    [TimeZoneEnum.Europe_Oslo]: {
        key: TimeZoneEnum.Europe_Oslo,
        value: "Europe/Oslo",
        label: "Europe/Oslo",
    },
    [TimeZoneEnum.Europe_Paris]: {
        key: TimeZoneEnum.Europe_Paris,
        value: "Europe/Paris",
        label: "Europe/Paris",
    },
    [TimeZoneEnum.Europe_Podgorica]: {
        key: TimeZoneEnum.Europe_Podgorica,
        value: "Europe/Podgorica",
        label: "Europe/Podgorica",
    },
    [TimeZoneEnum.Europe_Prague]: {
        key: TimeZoneEnum.Europe_Prague,
        value: "Europe/Prague",
        label: "Europe/Prague",
    },
    [TimeZoneEnum.Europe_Riga]: {
        key: TimeZoneEnum.Europe_Riga,
        value: "Europe/Riga",
        label: "Europe/Riga",
    },
    [TimeZoneEnum.Europe_Rome]: {
        key: TimeZoneEnum.Europe_Rome,
        value: "Europe/Rome",
        label: "Europe/Rome",
    },
    [TimeZoneEnum.Europe_Samara]: {
        key: TimeZoneEnum.Europe_Samara,
        value: "Europe/Samara",
        label: "Europe/Samara",
    },
    [TimeZoneEnum.Europe_San_Marino]: {
        key: TimeZoneEnum.Europe_San_Marino,
        value: "Europe/San_Marino",
        label: "Europe/San_Marino",
    },
    [TimeZoneEnum.Europe_Sarajevo]: {
        key: TimeZoneEnum.Europe_Sarajevo,
        value: "Europe/Sarajevo",
        label: "Europe/Sarajevo",
    },
    [TimeZoneEnum.Europe_Saratov]: {
        key: TimeZoneEnum.Europe_Saratov,
        value: "Europe/Saratov",
        label: "Europe/Saratov",
    },
    [TimeZoneEnum.Europe_Simferopol]: {
        key: TimeZoneEnum.Europe_Simferopol,
        value: "Europe/Simferopol",
        label: "Europe/Simferopol",
    },
    [TimeZoneEnum.Europe_Skopje]: {
        key: TimeZoneEnum.Europe_Skopje,
        value: "Europe/Skopje",
        label: "Europe/Skopje",
    },
    [TimeZoneEnum.Europe_Sofia]: {
        key: TimeZoneEnum.Europe_Sofia,
        value: "Europe/Sofia",
        label: "Europe/Sofia",
    },
    [TimeZoneEnum.Europe_Stockholm]: {
        key: TimeZoneEnum.Europe_Stockholm,
        value: "Europe/Stockholm",
        label: "Europe/Stockholm",
    },
    [TimeZoneEnum.Europe_Tallinn]: {
        key: TimeZoneEnum.Europe_Tallinn,
        value: "Europe/Tallinn",
        label: "Europe/Tallinn",
    },
    [TimeZoneEnum.Europe_Tirane]: {
        key: TimeZoneEnum.Europe_Tirane,
        value: "Europe/Tirane",
        label: "Europe/Tirane",
    },
    [TimeZoneEnum.Europe_Ulyanovsk]: {
        key: TimeZoneEnum.Europe_Ulyanovsk,
        value: "Europe/Ulyanovsk",
        label: "Europe/Ulyanovsk",
    },
    [TimeZoneEnum.Europe_Vaduz]: {
        key: TimeZoneEnum.Europe_Vaduz,
        value: "Europe/Vaduz",
        label: "Europe/Vaduz",
    },
    [TimeZoneEnum.Europe_Vatican]: {
        key: TimeZoneEnum.Europe_Vatican,
        value: "Europe/Vatican",
        label: "Europe/Vatican",
    },
    [TimeZoneEnum.Europe_Vienna]: {
        key: TimeZoneEnum.Europe_Vienna,
        value: "Europe/Vienna",
        label: "Europe/Vienna",
    },
    [TimeZoneEnum.Europe_Vilnius]: {
        key: TimeZoneEnum.Europe_Vilnius,
        value: "Europe/Vilnius",
        label: "Europe/Vilnius",
    },
    [TimeZoneEnum.Europe_Volgograd]: {
        key: TimeZoneEnum.Europe_Volgograd,
        value: "Europe/Volgograd",
        label: "Europe/Volgograd",
    },
    [TimeZoneEnum.Europe_Warsaw]: {
        key: TimeZoneEnum.Europe_Warsaw,
        value: "Europe/Warsaw",
        label: "Europe/Warsaw",
    },
    [TimeZoneEnum.Europe_Zagreb]: {
        key: TimeZoneEnum.Europe_Zagreb,
        value: "Europe/Zagreb",
        label: "Europe/Zagreb",
    },
    [TimeZoneEnum.Europe_Zurich]: {
        key: TimeZoneEnum.Europe_Zurich,
        value: "Europe/Zurich",
        label: "Europe/Zurich",
    },
    [TimeZoneEnum.Indian_Antananarivo]: {
        key: TimeZoneEnum.Indian_Antananarivo,
        value: "Indian/Antananarivo",
        label: "Indian/Antananarivo",
    },
    [TimeZoneEnum.Indian_Chagos]: {
        key: TimeZoneEnum.Indian_Chagos,
        value: "Indian/Chagos",
        label: "Indian/Chagos",
    },
    [TimeZoneEnum.Indian_Christmas]: {
        key: TimeZoneEnum.Indian_Christmas,
        value: "Indian/Christmas",
        label: "Indian/Christmas",
    },
    [TimeZoneEnum.Indian_Cocos]: {
        key: TimeZoneEnum.Indian_Cocos,
        value: "Indian/Cocos",
        label: "Indian/Cocos",
    },
    [TimeZoneEnum.Indian_Comoro]: {
        key: TimeZoneEnum.Indian_Comoro,
        value: "Indian/Comoro",
        label: "Indian/Comoro",
    },
    [TimeZoneEnum.Indian_Kerguelen]: {
        key: TimeZoneEnum.Indian_Kerguelen,
        value: "Indian/Kerguelen",
        label: "Indian/Kerguelen",
    },
    [TimeZoneEnum.Indian_Mahe]: {
        key: TimeZoneEnum.Indian_Mahe,
        value: "Indian/Mahe",
        label: "Indian/Mahe",
    },
    [TimeZoneEnum.Indian_Maldives]: {
        key: TimeZoneEnum.Indian_Maldives,
        value: "Indian/Maldives",
        label: "Indian/Maldives",
    },
    [TimeZoneEnum.Indian_Mauritius]: {
        key: TimeZoneEnum.Indian_Mauritius,
        value: "Indian/Mauritius",
        label: "Indian/Mauritius",
    },
    [TimeZoneEnum.Indian_Mayotte]: {
        key: TimeZoneEnum.Indian_Mayotte,
        value: "Indian/Mayotte",
        label: "Indian/Mayotte",
    },
    [TimeZoneEnum.Indian_Reunion]: {
        key: TimeZoneEnum.Indian_Reunion,
        value: "Indian/Reunion",
        label: "Indian/Reunion",
    },
    [TimeZoneEnum.Pacific_Apia]: {
        key: TimeZoneEnum.Pacific_Apia,
        value: "Pacific/Apia",
        label: "Pacific/Apia",
    },
    [TimeZoneEnum.Pacific_Auckland]: {
        key: TimeZoneEnum.Pacific_Auckland,
        value: "Pacific/Auckland",
        label: "Pacific/Auckland",
    },
    [TimeZoneEnum.Pacific_Bougainville]: {
        key: TimeZoneEnum.Pacific_Bougainville,
        value: "Pacific/Bougainville",
        label: "Pacific/Bougainville",
    },
    [TimeZoneEnum.Pacific_Chatham]: {
        key: TimeZoneEnum.Pacific_Chatham,
        value: "Pacific/Chatham",
        label: "Pacific/Chatham",
    },
    [TimeZoneEnum.Pacific_Chuuk]: {
        key: TimeZoneEnum.Pacific_Chuuk,
        value: "Pacific/Chuuk",
        label: "Pacific/Chuuk",
    },
    [TimeZoneEnum.Pacific_Easter]: {
        key: TimeZoneEnum.Pacific_Easter,
        value: "Pacific/Easter",
        label: "Pacific/Easter",
    },
    [TimeZoneEnum.Pacific_Efate]: {
        key: TimeZoneEnum.Pacific_Efate,
        value: "Pacific/Efate",
        label: "Pacific/Efate",
    },
    [TimeZoneEnum.Pacific_Fakaofo]: {
        key: TimeZoneEnum.Pacific_Fakaofo,
        value: "Pacific/Fakaofo",
        label: "Pacific/Fakaofo",
    },
    [TimeZoneEnum.Pacific_Fiji]: {
        key: TimeZoneEnum.Pacific_Fiji,
        value: "Pacific/Fiji",
        label: "Pacific/Fiji",
    },
    [TimeZoneEnum.Pacific_Funafuti]: {
        key: TimeZoneEnum.Pacific_Funafuti,
        value: "Pacific/Funafuti",
        label: "Pacific/Funafuti",
    },
    [TimeZoneEnum.Pacific_Galapagos]: {
        key: TimeZoneEnum.Pacific_Galapagos,
        value: "Pacific/Galapagos",
        label: "Pacific/Galapagos",
    },
    [TimeZoneEnum.Pacific_Gambier]: {
        key: TimeZoneEnum.Pacific_Gambier,
        value: "Pacific/Gambier",
        label: "Pacific/Gambier",
    },
    [TimeZoneEnum.Pacific_Guadalcanal]: {
        key: TimeZoneEnum.Pacific_Guadalcanal,
        value: "Pacific/Guadalcanal",
        label: "Pacific/Guadalcanal",
    },
    [TimeZoneEnum.Pacific_Guam]: {
        key: TimeZoneEnum.Pacific_Guam,
        value: "Pacific/Guam",
        label: "Pacific/Guam",
    },
    [TimeZoneEnum.Pacific_Honolulu]: {
        key: TimeZoneEnum.Pacific_Honolulu,
        value: "Pacific/Honolulu",
        label: "Pacific/Honolulu",
    },
    [TimeZoneEnum.Pacific_Kanton]: {
        key: TimeZoneEnum.Pacific_Kanton,
        value: "Pacific/Kanton",
        label: "Pacific/Kanton",
    },
    [TimeZoneEnum.Pacific_Kiritimati]: {
        key: TimeZoneEnum.Pacific_Kiritimati,
        value: "Pacific/Kiritimati",
        label: "Pacific/Kiritimati",
    },
    [TimeZoneEnum.Pacific_Kosrae]: {
        key: TimeZoneEnum.Pacific_Kosrae,
        value: "Pacific/Kosrae",
        label: "Pacific/Kosrae",
    },
    [TimeZoneEnum.Pacific_Kwajalein]: {
        key: TimeZoneEnum.Pacific_Kwajalein,
        value: "Pacific/Kwajalein",
        label: "Pacific/Kwajalein",
    },
    [TimeZoneEnum.Pacific_Majuro]: {
        key: TimeZoneEnum.Pacific_Majuro,
        value: "Pacific/Majuro",
        label: "Pacific/Majuro",
    },
    [TimeZoneEnum.Pacific_Marquesas]: {
        key: TimeZoneEnum.Pacific_Marquesas,
        value: "Pacific/Marquesas",
        label: "Pacific/Marquesas",
    },
    [TimeZoneEnum.Pacific_Midway]: {
        key: TimeZoneEnum.Pacific_Midway,
        value: "Pacific/Midway",
        label: "Pacific/Midway",
    },
    [TimeZoneEnum.Pacific_Nauru]: {
        key: TimeZoneEnum.Pacific_Nauru,
        value: "Pacific/Nauru",
        label: "Pacific/Nauru",
    },
    [TimeZoneEnum.Pacific_Niue]: {
        key: TimeZoneEnum.Pacific_Niue,
        value: "Pacific/Niue",
        label: "Pacific/Niue",
    },
    [TimeZoneEnum.Pacific_Norfolk]: {
        key: TimeZoneEnum.Pacific_Norfolk,
        value: "Pacific/Norfolk",
        label: "Pacific/Norfolk",
    },
    [TimeZoneEnum.Pacific_Noumea]: {
        key: TimeZoneEnum.Pacific_Noumea,
        value: "Pacific/Noumea",
        label: "Pacific/Noumea",
    },
    [TimeZoneEnum.Pacific_Pago_Pago]: {
        key: TimeZoneEnum.Pacific_Pago_Pago,
        value: "Pacific/Pago_Pago",
        label: "Pacific/Pago_Pago",
    },
    [TimeZoneEnum.Pacific_Palau]: {
        key: TimeZoneEnum.Pacific_Palau,
        value: "Pacific/Palau",
        label: "Pacific/Palau",
    },
    [TimeZoneEnum.Pacific_Pitcairn]: {
        key: TimeZoneEnum.Pacific_Pitcairn,
        value: "Pacific/Pitcairn",
        label: "Pacific/Pitcairn",
    },
    [TimeZoneEnum.Pacific_Pohnpei]: {
        key: TimeZoneEnum.Pacific_Pohnpei,
        value: "Pacific/Pohnpei",
        label: "Pacific/Pohnpei",
    },
    [TimeZoneEnum.Pacific_Port_Moresby]: {
        key: TimeZoneEnum.Pacific_Port_Moresby,
        value: "Pacific/Port_Moresby",
        label: "Pacific/Port_Moresby",
    },
    [TimeZoneEnum.Pacific_Rarotonga]: {
        key: TimeZoneEnum.Pacific_Rarotonga,
        value: "Pacific/Rarotonga",
        label: "Pacific/Rarotonga",
    },
    [TimeZoneEnum.Pacific_Saipan]: {
        key: TimeZoneEnum.Pacific_Saipan,
        value: "Pacific/Saipan",
        label: "Pacific/Saipan",
    },
    [TimeZoneEnum.Pacific_Tahiti]: {
        key: TimeZoneEnum.Pacific_Tahiti,
        value: "Pacific/Tahiti",
        label: "Pacific/Tahiti",
    },
    [TimeZoneEnum.Pacific_Tarawa]: {
        key: TimeZoneEnum.Pacific_Tarawa,
        value: "Pacific/Tarawa",
        label: "Pacific/Tarawa",
    },
    [TimeZoneEnum.Pacific_Tongatapu]: {
        key: TimeZoneEnum.Pacific_Tongatapu,
        value: "Pacific/Tongatapu",
        label: "Pacific/Tongatapu",
    },
    [TimeZoneEnum.Pacific_Wake]: {
        key: TimeZoneEnum.Pacific_Wake,
        value: "Pacific/Wake",
        label: "Pacific/Wake",
    },
    [TimeZoneEnum.Pacific_Wallis]: {
        key: TimeZoneEnum.Pacific_Wallis,
        value: "Pacific/Wallis",
        label: "Pacific/Wallis",
    },
    [TimeZoneEnum.UTC]: {
        key: TimeZoneEnum.UTC,
        value: "UTC",
        label: "UTC",
    },
} as const

export const TimeZoneEnumList = [
    {
        key: TimeZoneEnum.Africa_Abidjan,
        value: "Africa/Abidjan",
        label: "Africa/Abidjan",
    },
    {
        key: TimeZoneEnum.Africa_Accra,
        value: "Africa/Accra",
        label: "Africa/Accra",
    },
    {
        key: TimeZoneEnum.Africa_Addis_Ababa,
        value: "Africa/Addis_Ababa",
        label: "Africa/Addis_Ababa",
    },
    {
        key: TimeZoneEnum.Africa_Algiers,
        value: "Africa/Algiers",
        label: "Africa/Algiers",
    },
    {
        key: TimeZoneEnum.Africa_Asmara,
        value: "Africa/Asmara",
        label: "Africa/Asmara",
    },
    {
        key: TimeZoneEnum.Africa_Bamako,
        value: "Africa/Bamako",
        label: "Africa/Bamako",
    },
    {
        key: TimeZoneEnum.Africa_Bangui,
        value: "Africa/Bangui",
        label: "Africa/Bangui",
    },
    {
        key: TimeZoneEnum.Africa_Banjul,
        value: "Africa/Banjul",
        label: "Africa/Banjul",
    },
    {
        key: TimeZoneEnum.Africa_Bissau,
        value: "Africa/Bissau",
        label: "Africa/Bissau",
    },
    {
        key: TimeZoneEnum.Africa_Blantyre,
        value: "Africa/Blantyre",
        label: "Africa/Blantyre",
    },
    {
        key: TimeZoneEnum.Africa_Brazzaville,
        value: "Africa/Brazzaville",
        label: "Africa/Brazzaville",
    },
    {
        key: TimeZoneEnum.Africa_Bujumbura,
        value: "Africa/Bujumbura",
        label: "Africa/Bujumbura",
    },
    {
        key: TimeZoneEnum.Africa_Cairo,
        value: "Africa/Cairo",
        label: "Africa/Cairo",
    },
    {
        key: TimeZoneEnum.Africa_Casablanca,
        value: "Africa/Casablanca",
        label: "Africa/Casablanca",
    },
    {
        key: TimeZoneEnum.Africa_Ceuta,
        value: "Africa/Ceuta",
        label: "Africa/Ceuta",
    },
    {
        key: TimeZoneEnum.Africa_Conakry,
        value: "Africa/Conakry",
        label: "Africa/Conakry",
    },
    {
        key: TimeZoneEnum.Africa_Dakar,
        value: "Africa/Dakar",
        label: "Africa/Dakar",
    },
    {
        key: TimeZoneEnum.Africa_Dar_es_Salaam,
        value: "Africa/Dar_es_Salaam",
        label: "Africa/Dar_es_Salaam",
    },
    {
        key: TimeZoneEnum.Africa_Djibouti,
        value: "Africa/Djibouti",
        label: "Africa/Djibouti",
    },
    {
        key: TimeZoneEnum.Africa_Douala,
        value: "Africa/Douala",
        label: "Africa/Douala",
    },
    {
        key: TimeZoneEnum.Africa_El_Aaiun,
        value: "Africa/El_Aaiun",
        label: "Africa/El_Aaiun",
    },
    {
        key: TimeZoneEnum.Africa_Freetown,
        value: "Africa/Freetown",
        label: "Africa/Freetown",
    },
    {
        key: TimeZoneEnum.Africa_Gaborone,
        value: "Africa/Gaborone",
        label: "Africa/Gaborone",
    },
    {
        key: TimeZoneEnum.Africa_Harare,
        value: "Africa/Harare",
        label: "Africa/Harare",
    },
    {
        key: TimeZoneEnum.Africa_Johannesburg,
        value: "Africa/Johannesburg",
        label: "Africa/Johannesburg",
    },
    {
        key: TimeZoneEnum.Africa_Juba,
        value: "Africa/Juba",
        label: "Africa/Juba",
    },
    {
        key: TimeZoneEnum.Africa_Kampala,
        value: "Africa/Kampala",
        label: "Africa/Kampala",
    },
    {
        key: TimeZoneEnum.Africa_Khartoum,
        value: "Africa/Khartoum",
        label: "Africa/Khartoum",
    },
    {
        key: TimeZoneEnum.Africa_Kigali,
        value: "Africa/Kigali",
        label: "Africa/Kigali",
    },
    {
        key: TimeZoneEnum.Africa_Kinshasa,
        value: "Africa/Kinshasa",
        label: "Africa/Kinshasa",
    },
    {
        key: TimeZoneEnum.Africa_Lagos,
        value: "Africa/Lagos",
        label: "Africa/Lagos",
    },
    {
        key: TimeZoneEnum.Africa_Libreville,
        value: "Africa/Libreville",
        label: "Africa/Libreville",
    },
    {
        key: TimeZoneEnum.Africa_Lome,
        value: "Africa/Lome",
        label: "Africa/Lome",
    },
    {
        key: TimeZoneEnum.Africa_Luanda,
        value: "Africa/Luanda",
        label: "Africa/Luanda",
    },
    {
        key: TimeZoneEnum.Africa_Lubumbashi,
        value: "Africa/Lubumbashi",
        label: "Africa/Lubumbashi",
    },
    {
        key: TimeZoneEnum.Africa_Lusaka,
        value: "Africa/Lusaka",
        label: "Africa/Lusaka",
    },
    {
        key: TimeZoneEnum.Africa_Malabo,
        value: "Africa/Malabo",
        label: "Africa/Malabo",
    },
    {
        key: TimeZoneEnum.Africa_Maputo,
        value: "Africa/Maputo",
        label: "Africa/Maputo",
    },
    {
        key: TimeZoneEnum.Africa_Maseru,
        value: "Africa/Maseru",
        label: "Africa/Maseru",
    },
    {
        key: TimeZoneEnum.Africa_Mbabane,
        value: "Africa/Mbabane",
        label: "Africa/Mbabane",
    },
    {
        key: TimeZoneEnum.Africa_Mogadishu,
        value: "Africa/Mogadishu",
        label: "Africa/Mogadishu",
    },
    {
        key: TimeZoneEnum.Africa_Monrovia,
        value: "Africa/Monrovia",
        label: "Africa/Monrovia",
    },
    {
        key: TimeZoneEnum.Africa_Nairobi,
        value: "Africa/Nairobi",
        label: "Africa/Nairobi",
    },
    {
        key: TimeZoneEnum.Africa_Ndjamena,
        value: "Africa/Ndjamena",
        label: "Africa/Ndjamena",
    },
    {
        key: TimeZoneEnum.Africa_Niamey,
        value: "Africa/Niamey",
        label: "Africa/Niamey",
    },
    {
        key: TimeZoneEnum.Africa_Nouakchott,
        value: "Africa/Nouakchott",
        label: "Africa/Nouakchott",
    },
    {
        key: TimeZoneEnum.Africa_Ouagadougou,
        value: "Africa/Ouagadougou",
        label: "Africa/Ouagadougou",
    },
    {
        key: TimeZoneEnum.Africa_Porto_Novo,
        value: "Africa/Porto-Novo",
        label: "Africa/Porto-Novo",
    },
    {
        key: TimeZoneEnum.Africa_Sao_Tome,
        value: "Africa/Sao_Tome",
        label: "Africa/Sao_Tome",
    },
    {
        key: TimeZoneEnum.Africa_Tripoli,
        value: "Africa/Tripoli",
        label: "Africa/Tripoli",
    },
    {
        key: TimeZoneEnum.Africa_Tunis,
        value: "Africa/Tunis",
        label: "Africa/Tunis",
    },
    {
        key: TimeZoneEnum.Africa_Windhoek,
        value: "Africa/Windhoek",
        label: "Africa/Windhoek",
    },
    {
        key: TimeZoneEnum.America_Adak,
        value: "America/Adak",
        label: "America/Adak",
    },
    {
        key: TimeZoneEnum.America_Anchorage,
        value: "America/Anchorage",
        label: "America/Anchorage",
    },
    {
        key: TimeZoneEnum.America_Anguilla,
        value: "America/Anguilla",
        label: "America/Anguilla",
    },
    {
        key: TimeZoneEnum.America_Antigua,
        value: "America/Antigua",
        label: "America/Antigua",
    },
    {
        key: TimeZoneEnum.America_Araguaina,
        value: "America/Araguaina",
        label: "America/Araguaina",
    },
    {
        key: TimeZoneEnum.America_Argentina_Buenos_Aires,
        value: "America/Argentina/Buenos_Aires",
        label: "America/Argentina/Buenos_Aires",
    },
    {
        key: TimeZoneEnum.America_Argentina_Catamarca,
        value: "America/Argentina/Catamarca",
        label: "America/Argentina/Catamarca",
    },
    {
        key: TimeZoneEnum.America_Argentina_Cordoba,
        value: "America/Argentina/Cordoba",
        label: "America/Argentina/Cordoba",
    },
    {
        key: TimeZoneEnum.America_Argentina_Jujuy,
        value: "America/Argentina/Jujuy",
        label: "America/Argentina/Jujuy",
    },
    {
        key: TimeZoneEnum.America_Argentina_La_Rioja,
        value: "America/Argentina/La_Rioja",
        label: "America/Argentina/La_Rioja",
    },
    {
        key: TimeZoneEnum.America_Argentina_Mendoza,
        value: "America/Argentina/Mendoza",
        label: "America/Argentina/Mendoza",
    },
    {
        key: TimeZoneEnum.America_Argentina_Rio_Gallegos,
        value: "America/Argentina/Rio_Gallegos",
        label: "America/Argentina/Rio_Gallegos",
    },
    {
        key: TimeZoneEnum.America_Argentina_Salta,
        value: "America/Argentina/Salta",
        label: "America/Argentina/Salta",
    },
    {
        key: TimeZoneEnum.America_Argentina_San_Juan,
        value: "America/Argentina/San_Juan",
        label: "America/Argentina/San_Juan",
    },
    {
        key: TimeZoneEnum.America_Argentina_San_Luis,
        value: "America/Argentina/San_Luis",
        label: "America/Argentina/San_Luis",
    },
    {
        key: TimeZoneEnum.America_Argentina_Tucuman,
        value: "America/Argentina/Tucuman",
        label: "America/Argentina/Tucuman",
    },
    {
        key: TimeZoneEnum.America_Argentina_Ushuaia,
        value: "America/Argentina/Ushuaia",
        label: "America/Argentina/Ushuaia",
    },
    {
        key: TimeZoneEnum.America_Aruba,
        value: "America/Aruba",
        label: "America/Aruba",
    },
    {
        key: TimeZoneEnum.America_Asuncion,
        value: "America/Asuncion",
        label: "America/Asuncion",
    },
    {
        key: TimeZoneEnum.America_Atikokan,
        value: "America/Atikokan",
        label: "America/Atikokan",
    },
    {
        key: TimeZoneEnum.America_Bahia,
        value: "America/Bahia",
        label: "America/Bahia",
    },
    {
        key: TimeZoneEnum.America_Bahia_Banderas,
        value: "America/Bahia_Banderas",
        label: "America/Bahia_Banderas",
    },
    {
        key: TimeZoneEnum.America_Barbados,
        value: "America/Barbados",
        label: "America/Barbados",
    },
    {
        key: TimeZoneEnum.America_Belem,
        value: "America/Belem",
        label: "America/Belem",
    },
    {
        key: TimeZoneEnum.America_Belize,
        value: "America/Belize",
        label: "America/Belize",
    },
    {
        key: TimeZoneEnum.America_Blanc_Sablon,
        value: "America/Blanc-Sablon",
        label: "America/Blanc-Sablon",
    },
    {
        key: TimeZoneEnum.America_Boa_Vista,
        value: "America/Boa_Vista",
        label: "America/Boa_Vista",
    },
    {
        key: TimeZoneEnum.America_Bogota,
        value: "America/Bogota",
        label: "America/Bogota",
    },
    {
        key: TimeZoneEnum.America_Boise,
        value: "America/Boise",
        label: "America/Boise",
    },
    {
        key: TimeZoneEnum.America_Cambridge_Bay,
        value: "America/Cambridge_Bay",
        label: "America/Cambridge_Bay",
    },
    {
        key: TimeZoneEnum.America_Campo_Grande,
        value: "America/Campo_Grande",
        label: "America/Campo_Grande",
    },
    {
        key: TimeZoneEnum.America_Cancun,
        value: "America/Cancun",
        label: "America/Cancun",
    },
    {
        key: TimeZoneEnum.America_Caracas,
        value: "America/Caracas",
        label: "America/Caracas",
    },
    {
        key: TimeZoneEnum.America_Cayenne,
        value: "America/Cayenne",
        label: "America/Cayenne",
    },
    {
        key: TimeZoneEnum.America_Cayman,
        value: "America/Cayman",
        label: "America/Cayman",
    },
    {
        key: TimeZoneEnum.America_Chicago,
        value: "America/Chicago",
        label: "America/Chicago",
    },
    {
        key: TimeZoneEnum.America_Chihuahua,
        value: "America/Chihuahua",
        label: "America/Chihuahua",
    },
    {
        key: TimeZoneEnum.America_Ciudad_Juarez,
        value: "America/Ciudad_Juarez",
        label: "America/Ciudad_Juarez",
    },
    {
        key: TimeZoneEnum.America_Costa_Rica,
        value: "America/Costa_Rica",
        label: "America/Costa_Rica",
    },
    {
        key: TimeZoneEnum.America_Creston,
        value: "America/Creston",
        label: "America/Creston",
    },
    {
        key: TimeZoneEnum.America_Cuiaba,
        value: "America/Cuiaba",
        label: "America/Cuiaba",
    },
    {
        key: TimeZoneEnum.America_Curacao,
        value: "America/Curacao",
        label: "America/Curacao",
    },
    {
        key: TimeZoneEnum.America_Danmarkshavn,
        value: "America/Danmarkshavn",
        label: "America/Danmarkshavn",
    },
    {
        key: TimeZoneEnum.America_Dawson,
        value: "America/Dawson",
        label: "America/Dawson",
    },
    {
        key: TimeZoneEnum.America_Dawson_Creek,
        value: "America/Dawson_Creek",
        label: "America/Dawson_Creek",
    },
    {
        key: TimeZoneEnum.America_Denver,
        value: "America/Denver",
        label: "America/Denver",
    },
    {
        key: TimeZoneEnum.America_Detroit,
        value: "America/Detroit",
        label: "America/Detroit",
    },
    {
        key: TimeZoneEnum.America_Dominica,
        value: "America/Dominica",
        label: "America/Dominica",
    },
    {
        key: TimeZoneEnum.America_Edmonton,
        value: "America/Edmonton",
        label: "America/Edmonton",
    },
    {
        key: TimeZoneEnum.America_Eirunepe,
        value: "America/Eirunepe",
        label: "America/Eirunepe",
    },
    {
        key: TimeZoneEnum.America_El_Salvador,
        value: "America/El_Salvador",
        label: "America/El_Salvador",
    },
    {
        key: TimeZoneEnum.America_Fort_Nelson,
        value: "America/Fort_Nelson",
        label: "America/Fort_Nelson",
    },
    {
        key: TimeZoneEnum.America_Fortaleza,
        value: "America/Fortaleza",
        label: "America/Fortaleza",
    },
    {
        key: TimeZoneEnum.America_Glace_Bay,
        value: "America/Glace_Bay",
        label: "America/Glace_Bay",
    },
    {
        key: TimeZoneEnum.America_Goose_Bay,
        value: "America/Goose_Bay",
        label: "America/Goose_Bay",
    },
    {
        key: TimeZoneEnum.America_Grand_Turk,
        value: "America/Grand_Turk",
        label: "America/Grand_Turk",
    },
    {
        key: TimeZoneEnum.America_Grenada,
        value: "America/Grenada",
        label: "America/Grenada",
    },
    {
        key: TimeZoneEnum.America_Guadeloupe,
        value: "America/Guadeloupe",
        label: "America/Guadeloupe",
    },
    {
        key: TimeZoneEnum.America_Guatemala,
        value: "America/Guatemala",
        label: "America/Guatemala",
    },
    {
        key: TimeZoneEnum.America_Guayaquil,
        value: "America/Guayaquil",
        label: "America/Guayaquil",
    },
    {
        key: TimeZoneEnum.America_Guyana,
        value: "America/Guyana",
        label: "America/Guyana",
    },
    {
        key: TimeZoneEnum.America_Halifax,
        value: "America/Halifax",
        label: "America/Halifax",
    },
    {
        key: TimeZoneEnum.America_Havana,
        value: "America/Havana",
        label: "America/Havana",
    },
    {
        key: TimeZoneEnum.America_Hermosillo,
        value: "America/Hermosillo",
        label: "America/Hermosillo",
    },
    {
        key: TimeZoneEnum.America_Indiana_Indianapolis,
        value: "America/Indiana/Indianapolis",
        label: "America/Indiana/Indianapolis",
    },
    {
        key: TimeZoneEnum.America_Indiana_Knox,
        value: "America/Indiana/Knox",
        label: "America/Indiana/Knox",
    },
    {
        key: TimeZoneEnum.America_Indiana_Marengo,
        value: "America/Indiana/Marengo",
        label: "America/Indiana/Marengo",
    },
    {
        key: TimeZoneEnum.America_Indiana_Petersburg,
        value: "America/Indiana/Petersburg",
        label: "America/Indiana/Petersburg",
    },
    {
        key: TimeZoneEnum.America_Indiana_Tell_City,
        value: "America/Indiana/Tell_City",
        label: "America/Indiana/Tell_City",
    },
    {
        key: TimeZoneEnum.America_Indiana_Vevay,
        value: "America/Indiana/Vevay",
        label: "America/Indiana/Vevay",
    },
    {
        key: TimeZoneEnum.America_Indiana_Vincennes,
        value: "America/Indiana/Vincennes",
        label: "America/Indiana/Vincennes",
    },
    {
        key: TimeZoneEnum.America_Indiana_Winamac,
        value: "America/Indiana/Winamac",
        label: "America/Indiana/Winamac",
    },
    {
        key: TimeZoneEnum.America_Inuvik,
        value: "America/Inuvik",
        label: "America/Inuvik",
    },
    {
        key: TimeZoneEnum.America_Iqaluit,
        value: "America/Iqaluit",
        label: "America/Iqaluit",
    },
    {
        key: TimeZoneEnum.America_Jamaica,
        value: "America/Jamaica",
        label: "America/Jamaica",
    },
    {
        key: TimeZoneEnum.America_Juneau,
        value: "America/Juneau",
        label: "America/Juneau",
    },
    {
        key: TimeZoneEnum.America_Kentucky_Louisville,
        value: "America/Kentucky/Louisville",
        label: "America/Kentucky/Louisville",
    },
    {
        key: TimeZoneEnum.America_Kentucky_Monticello,
        value: "America/Kentucky/Monticello",
        label: "America/Kentucky/Monticello",
    },
    {
        key: TimeZoneEnum.America_Kralendijk,
        value: "America/Kralendijk",
        label: "America/Kralendijk",
    },
    {
        key: TimeZoneEnum.America_La_Paz,
        value: "America/La_Paz",
        label: "America/La_Paz",
    },
    {
        key: TimeZoneEnum.America_Lima,
        value: "America/Lima",
        label: "America/Lima",
    },
    {
        key: TimeZoneEnum.America_Los_Angeles,
        value: "America/Los_Angeles",
        label: "America/Los_Angeles",
    },
    {
        key: TimeZoneEnum.America_Lower_Princes,
        value: "America/Lower_Princes",
        label: "America/Lower_Princes",
    },
    {
        key: TimeZoneEnum.America_Maceio,
        value: "America/Maceio",
        label: "America/Maceio",
    },
    {
        key: TimeZoneEnum.America_Managua,
        value: "America/Managua",
        label: "America/Managua",
    },
    {
        key: TimeZoneEnum.America_Manaus,
        value: "America/Manaus",
        label: "America/Manaus",
    },
    {
        key: TimeZoneEnum.America_Marigot,
        value: "America/Marigot",
        label: "America/Marigot",
    },
    {
        key: TimeZoneEnum.America_Martinique,
        value: "America/Martinique",
        label: "America/Martinique",
    },
    {
        key: TimeZoneEnum.America_Matamoros,
        value: "America/Matamoros",
        label: "America/Matamoros",
    },
    {
        key: TimeZoneEnum.America_Mazatlan,
        value: "America/Mazatlan",
        label: "America/Mazatlan",
    },
    {
        key: TimeZoneEnum.America_Menominee,
        value: "America/Menominee",
        label: "America/Menominee",
    },
    {
        key: TimeZoneEnum.America_Merida,
        value: "America/Merida",
        label: "America/Merida",
    },
    {
        key: TimeZoneEnum.America_Metlakatla,
        value: "America/Metlakatla",
        label: "America/Metlakatla",
    },
    {
        key: TimeZoneEnum.America_Mexico_City,
        value: "America/Mexico_City",
        label: "America/Mexico_City",
    },
    {
        key: TimeZoneEnum.America_Miquelon,
        value: "America/Miquelon",
        label: "America/Miquelon",
    },
    {
        key: TimeZoneEnum.America_Moncton,
        value: "America/Moncton",
        label: "America/Moncton",
    },
    {
        key: TimeZoneEnum.America_Monterrey,
        value: "America/Monterrey",
        label: "America/Monterrey",
    },
    {
        key: TimeZoneEnum.America_Montevideo,
        value: "America/Montevideo",
        label: "America/Montevideo",
    },
    {
        key: TimeZoneEnum.America_Montserrat,
        value: "America/Montserrat",
        label: "America/Montserrat",
    },
    {
        key: TimeZoneEnum.America_Nassau,
        value: "America/Nassau",
        label: "America/Nassau",
    },
    {
        key: TimeZoneEnum.America_New_York,
        value: "America/New_York",
        label: "America/New_York",
    },
    {
        key: TimeZoneEnum.America_Nome,
        value: "America/Nome",
        label: "America/Nome",
    },
    {
        key: TimeZoneEnum.America_Noronha,
        value: "America/Noronha",
        label: "America/Noronha",
    },
    {
        key: TimeZoneEnum.America_North_Dakota_Beulah,
        value: "America/North_Dakota/Beulah",
        label: "America/North_Dakota/Beulah",
    },
    {
        key: TimeZoneEnum.America_North_Dakota_Center,
        value: "America/North_Dakota/Center",
        label: "America/North_Dakota/Center",
    },
    {
        key: TimeZoneEnum.America_North_Dakota_New_Salem,
        value: "America/North_Dakota/New_Salem",
        label: "America/North_Dakota/New_Salem",
    },
    {
        key: TimeZoneEnum.America_Nuuk,
        value: "America/Nuuk",
        label: "America/Nuuk",
    },
    {
        key: TimeZoneEnum.America_Ojinaga,
        value: "America/Ojinaga",
        label: "America/Ojinaga",
    },
    {
        key: TimeZoneEnum.America_Panama,
        value: "America/Panama",
        label: "America/Panama",
    },
    {
        key: TimeZoneEnum.America_Paramaribo,
        value: "America/Paramaribo",
        label: "America/Paramaribo",
    },
    {
        key: TimeZoneEnum.America_Phoenix,
        value: "America/Phoenix",
        label: "America/Phoenix",
    },
    {
        key: TimeZoneEnum.America_Port_au_Prince,
        value: "America/Port-au-Prince",
        label: "America/Port-au-Prince",
    },
    {
        key: TimeZoneEnum.America_Port_of_Spain,
        value: "America/Port_of_Spain",
        label: "America/Port_of_Spain",
    },
    {
        key: TimeZoneEnum.America_Porto_Velho,
        value: "America/Porto_Velho",
        label: "America/Porto_Velho",
    },
    {
        key: TimeZoneEnum.America_Puerto_Rico,
        value: "America/Puerto_Rico",
        label: "America/Puerto_Rico",
    },
    {
        key: TimeZoneEnum.America_Punta_Arenas,
        value: "America/Punta_Arenas",
        label: "America/Punta_Arenas",
    },
    {
        key: TimeZoneEnum.America_Rankin_Inlet,
        value: "America/Rankin_Inlet",
        label: "America/Rankin_Inlet",
    },
    {
        key: TimeZoneEnum.America_Recife,
        value: "America/Recife",
        label: "America/Recife",
    },
    {
        key: TimeZoneEnum.America_Regina,
        value: "America/Regina",
        label: "America/Regina",
    },
    {
        key: TimeZoneEnum.America_Resolute,
        value: "America/Resolute",
        label: "America/Resolute",
    },
    {
        key: TimeZoneEnum.America_Rio_Branco,
        value: "America/Rio_Branco",
        label: "America/Rio_Branco",
    },
    {
        key: TimeZoneEnum.America_Santarem,
        value: "America/Santarem",
        label: "America/Santarem",
    },
    {
        key: TimeZoneEnum.America_Santiago,
        value: "America/Santiago",
        label: "America/Santiago",
    },
    {
        key: TimeZoneEnum.America_Santo_Domingo,
        value: "America/Santo_Domingo",
        label: "America/Santo_Domingo",
    },
    {
        key: TimeZoneEnum.America_Sao_Paulo,
        value: "America/Sao_Paulo",
        label: "America/Sao_Paulo",
    },
    {
        key: TimeZoneEnum.America_Scoresbysund,
        value: "America/Scoresbysund",
        label: "America/Scoresbysund",
    },
    {
        key: TimeZoneEnum.America_Sitka,
        value: "America/Sitka",
        label: "America/Sitka",
    },
    {
        key: TimeZoneEnum.America_St_Barthelemy,
        value: "America/St_Barthelemy",
        label: "America/St_Barthelemy",
    },
    {
        key: TimeZoneEnum.America_St_Johns,
        value: "America/St_Johns",
        label: "America/St_Johns",
    },
    {
        key: TimeZoneEnum.America_St_Kitts,
        value: "America/St_Kitts",
        label: "America/St_Kitts",
    },
    {
        key: TimeZoneEnum.America_St_Lucia,
        value: "America/St_Lucia",
        label: "America/St_Lucia",
    },
    {
        key: TimeZoneEnum.America_St_Thomas,
        value: "America/St_Thomas",
        label: "America/St_Thomas",
    },
    {
        key: TimeZoneEnum.America_St_Vincent,
        value: "America/St_Vincent",
        label: "America/St_Vincent",
    },
    {
        key: TimeZoneEnum.America_Swift_Current,
        value: "America/Swift_Current",
        label: "America/Swift_Current",
    },
    {
        key: TimeZoneEnum.America_Tegucigalpa,
        value: "America/Tegucigalpa",
        label: "America/Tegucigalpa",
    },
    {
        key: TimeZoneEnum.America_Thule,
        value: "America/Thule",
        label: "America/Thule",
    },
    {
        key: TimeZoneEnum.America_Tijuana,
        value: "America/Tijuana",
        label: "America/Tijuana",
    },
    {
        key: TimeZoneEnum.America_Toronto,
        value: "America/Toronto",
        label: "America/Toronto",
    },
    {
        key: TimeZoneEnum.America_Tortola,
        value: "America/Tortola",
        label: "America/Tortola",
    },
    {
        key: TimeZoneEnum.America_Vancouver,
        value: "America/Vancouver",
        label: "America/Vancouver",
    },
    {
        key: TimeZoneEnum.America_Whitehorse,
        value: "America/Whitehorse",
        label: "America/Whitehorse",
    },
    {
        key: TimeZoneEnum.America_Winnipeg,
        value: "America/Winnipeg",
        label: "America/Winnipeg",
    },
    {
        key: TimeZoneEnum.America_Yakutat,
        value: "America/Yakutat",
        label: "America/Yakutat",
    },
    {
        key: TimeZoneEnum.Antarctica_Casey,
        value: "Antarctica/Casey",
        label: "Antarctica/Casey",
    },
    {
        key: TimeZoneEnum.Antarctica_Davis,
        value: "Antarctica/Davis",
        label: "Antarctica/Davis",
    },
    {
        key: TimeZoneEnum.Antarctica_DumontDUrville,
        value: "Antarctica/DumontDUrville",
        label: "Antarctica/DumontDUrville",
    },
    {
        key: TimeZoneEnum.Antarctica_Macquarie,
        value: "Antarctica/Macquarie",
        label: "Antarctica/Macquarie",
    },
    {
        key: TimeZoneEnum.Antarctica_Mawson,
        value: "Antarctica/Mawson",
        label: "Antarctica/Mawson",
    },
    {
        key: TimeZoneEnum.Antarctica_McMurdo,
        value: "Antarctica/McMurdo",
        label: "Antarctica/McMurdo",
    },
    {
        key: TimeZoneEnum.Antarctica_Palmer,
        value: "Antarctica/Palmer",
        label: "Antarctica/Palmer",
    },
    {
        key: TimeZoneEnum.Antarctica_Rothera,
        value: "Antarctica/Rothera",
        label: "Antarctica/Rothera",
    },
    {
        key: TimeZoneEnum.Antarctica_Syowa,
        value: "Antarctica/Syowa",
        label: "Antarctica/Syowa",
    },
    {
        key: TimeZoneEnum.Antarctica_Troll,
        value: "Antarctica/Troll",
        label: "Antarctica/Troll",
    },
    {
        key: TimeZoneEnum.Antarctica_Vostok,
        value: "Antarctica/Vostok",
        label: "Antarctica/Vostok",
    },
    {
        key: TimeZoneEnum.Arctic_Longyearbyen,
        value: "Arctic/Longyearbyen",
        label: "Arctic/Longyearbyen",
    },
    {
        key: TimeZoneEnum.Asia_Aden,
        value: "Asia/Aden",
        label: "Asia/Aden",
    },
    {
        key: TimeZoneEnum.Asia_Almaty,
        value: "Asia/Almaty",
        label: "Asia/Almaty",
    },
    {
        key: TimeZoneEnum.Asia_Amman,
        value: "Asia/Amman",
        label: "Asia/Amman",
    },
    {
        key: TimeZoneEnum.Asia_Anadyr,
        value: "Asia/Anadyr",
        label: "Asia/Anadyr",
    },
    {
        key: TimeZoneEnum.Asia_Aqtau,
        value: "Asia/Aqtau",
        label: "Asia/Aqtau",
    },
    {
        key: TimeZoneEnum.Asia_Aqtobe,
        value: "Asia/Aqtobe",
        label: "Asia/Aqtobe",
    },
    {
        key: TimeZoneEnum.Asia_Ashgabat,
        value: "Asia/Ashgabat",
        label: "Asia/Ashgabat",
    },
    {
        key: TimeZoneEnum.Asia_Atyrau,
        value: "Asia/Atyrau",
        label: "Asia/Atyrau",
    },
    {
        key: TimeZoneEnum.Asia_Baghdad,
        value: "Asia/Baghdad",
        label: "Asia/Baghdad",
    },
    {
        key: TimeZoneEnum.Asia_Bahrain,
        value: "Asia/Bahrain",
        label: "Asia/Bahrain",
    },
    {
        key: TimeZoneEnum.Asia_Baku,
        value: "Asia/Baku",
        label: "Asia/Baku",
    },
    {
        key: TimeZoneEnum.Asia_Bangkok,
        value: "Asia/Bangkok",
        label: "Asia/Bangkok",
    },
    {
        key: TimeZoneEnum.Asia_Barnaul,
        value: "Asia/Barnaul",
        label: "Asia/Barnaul",
    },
    {
        key: TimeZoneEnum.Asia_Beirut,
        value: "Asia/Beirut",
        label: "Asia/Beirut",
    },
    {
        key: TimeZoneEnum.Asia_Bishkek,
        value: "Asia/Bishkek",
        label: "Asia/Bishkek",
    },
    {
        key: TimeZoneEnum.Asia_Brunei,
        value: "Asia/Brunei",
        label: "Asia/Brunei",
    },
    {
        key: TimeZoneEnum.Asia_Chita,
        value: "Asia/Chita",
        label: "Asia/Chita",
    },
    {
        key: TimeZoneEnum.Asia_Colombo,
        value: "Asia/Colombo",
        label: "Asia/Colombo",
    },
    {
        key: TimeZoneEnum.Asia_Damascus,
        value: "Asia/Damascus",
        label: "Asia/Damascus",
    },
    {
        key: TimeZoneEnum.Asia_Dhaka,
        value: "Asia/Dhaka",
        label: "Asia/Dhaka",
    },
    {
        key: TimeZoneEnum.Asia_Dili,
        value: "Asia/Dili",
        label: "Asia/Dili",
    },
    {
        key: TimeZoneEnum.Asia_Dubai,
        value: "Asia/Dubai",
        label: "Asia/Dubai",
    },
    {
        key: TimeZoneEnum.Asia_Dushanbe,
        value: "Asia/Dushanbe",
        label: "Asia/Dushanbe",
    },
    {
        key: TimeZoneEnum.Asia_Famagusta,
        value: "Asia/Famagusta",
        label: "Asia/Famagusta",
    },
    {
        key: TimeZoneEnum.Asia_Gaza,
        value: "Asia/Gaza",
        label: "Asia/Gaza",
    },
    {
        key: TimeZoneEnum.Asia_Hebron,
        value: "Asia/Hebron",
        label: "Asia/Hebron",
    },
    {
        key: TimeZoneEnum.Asia_Ho_Chi_Minh,
        value: "Asia/Ho_Chi_Minh",
        label: "Asia/Ho_Chi_Minh",
    },
    {
        key: TimeZoneEnum.Asia_Hong_Kong,
        value: "Asia/Hong_Kong",
        label: "Asia/Hong_Kong",
    },
    {
        key: TimeZoneEnum.Asia_Hovd,
        value: "Asia/Hovd",
        label: "Asia/Hovd",
    },
    {
        key: TimeZoneEnum.Asia_Irkutsk,
        value: "Asia/Irkutsk",
        label: "Asia/Irkutsk",
    },
    {
        key: TimeZoneEnum.Asia_Jakarta,
        value: "Asia/Jakarta",
        label: "Asia/Jakarta",
    },
    {
        key: TimeZoneEnum.Asia_Jayapura,
        value: "Asia/Jayapura",
        label: "Asia/Jayapura",
    },
    {
        key: TimeZoneEnum.Asia_Jerusalem,
        value: "Asia/Jerusalem",
        label: "Asia/Jerusalem",
    },
    {
        key: TimeZoneEnum.Asia_Kabul,
        value: "Asia/Kabul",
        label: "Asia/Kabul",
    },
    {
        key: TimeZoneEnum.Asia_Kamchatka,
        value: "Asia/Kamchatka",
        label: "Asia/Kamchatka",
    },
    {
        key: TimeZoneEnum.Asia_Karachi,
        value: "Asia/Karachi",
        label: "Asia/Karachi",
    },
    {
        key: TimeZoneEnum.Asia_Kathmandu,
        value: "Asia/Kathmandu",
        label: "Asia/Kathmandu",
    },
    {
        key: TimeZoneEnum.Asia_Khandyga,
        value: "Asia/Khandyga",
        label: "Asia/Khandyga",
    },
    {
        key: TimeZoneEnum.Asia_Kolkata,
        value: "Asia/Kolkata",
        label: "Asia/Kolkata",
    },
    {
        key: TimeZoneEnum.Asia_Krasnoyarsk,
        value: "Asia/Krasnoyarsk",
        label: "Asia/Krasnoyarsk",
    },
    {
        key: TimeZoneEnum.Asia_Kuala_Lumpur,
        value: "Asia/Kuala_Lumpur",
        label: "Asia/Kuala_Lumpur",
    },
    {
        key: TimeZoneEnum.Asia_Kuching,
        value: "Asia/Kuching",
        label: "Asia/Kuching",
    },
    {
        key: TimeZoneEnum.Asia_Kuwait,
        value: "Asia/Kuwait",
        label: "Asia/Kuwait",
    },
    {
        key: TimeZoneEnum.Asia_Macau,
        value: "Asia/Macau",
        label: "Asia/Macau",
    },
    {
        key: TimeZoneEnum.Asia_Magadan,
        value: "Asia/Magadan",
        label: "Asia/Magadan",
    },
    {
        key: TimeZoneEnum.Asia_Makassar,
        value: "Asia/Makassar",
        label: "Asia/Makassar",
    },
    {
        key: TimeZoneEnum.Asia_Manila,
        value: "Asia/Manila",
        label: "Asia/Manila",
    },
    {
        key: TimeZoneEnum.Asia_Muscat,
        value: "Asia/Muscat",
        label: "Asia/Muscat",
    },
    {
        key: TimeZoneEnum.Asia_Nicosia,
        value: "Asia/Nicosia",
        label: "Asia/Nicosia",
    },
    {
        key: TimeZoneEnum.Asia_Novokuznetsk,
        value: "Asia/Novokuznetsk",
        label: "Asia/Novokuznetsk",
    },
    {
        key: TimeZoneEnum.Asia_Novosibirsk,
        value: "Asia/Novosibirsk",
        label: "Asia/Novosibirsk",
    },
    {
        key: TimeZoneEnum.Asia_Omsk,
        value: "Asia/Omsk",
        label: "Asia/Omsk",
    },
    {
        key: TimeZoneEnum.Asia_Oral,
        value: "Asia/Oral",
        label: "Asia/Oral",
    },
    {
        key: TimeZoneEnum.Asia_Phnom_Penh,
        value: "Asia/Phnom_Penh",
        label: "Asia/Phnom_Penh",
    },
    {
        key: TimeZoneEnum.Asia_Pontianak,
        value: "Asia/Pontianak",
        label: "Asia/Pontianak",
    },
    {
        key: TimeZoneEnum.Asia_Pyongyang,
        value: "Asia/Pyongyang",
        label: "Asia/Pyongyang",
    },
    {
        key: TimeZoneEnum.Asia_Qatar,
        value: "Asia/Qatar",
        label: "Asia/Qatar",
    },
    {
        key: TimeZoneEnum.Asia_Qostanay,
        value: "Asia/Qostanay",
        label: "Asia/Qostanay",
    },
    {
        key: TimeZoneEnum.Asia_Qyzylorda,
        value: "Asia/Qyzylorda",
        label: "Asia/Qyzylorda",
    },
    {
        key: TimeZoneEnum.Asia_Riyadh,
        value: "Asia/Riyadh",
        label: "Asia/Riyadh",
    },
    {
        key: TimeZoneEnum.Asia_Sakhalin,
        value: "Asia/Sakhalin",
        label: "Asia/Sakhalin",
    },
    {
        key: TimeZoneEnum.Asia_Samarkand,
        value: "Asia/Samarkand",
        label: "Asia/Samarkand",
    },
    {
        key: TimeZoneEnum.Asia_Seoul,
        value: "Asia/Seoul",
        label: "Asia/Seoul",
    },
    {
        key: TimeZoneEnum.Asia_Shanghai,
        value: "Asia/Shanghai",
        label: "Asia/Shanghai",
    },
    {
        key: TimeZoneEnum.Asia_Singapore,
        value: "Asia/Singapore",
        label: "Asia/Singapore",
    },
    {
        key: TimeZoneEnum.Asia_Srednekolymsk,
        value: "Asia/Srednekolymsk",
        label: "Asia/Srednekolymsk",
    },
    {
        key: TimeZoneEnum.Asia_Taipei,
        value: "Asia/Taipei",
        label: "Asia/Taipei",
    },
    {
        key: TimeZoneEnum.Asia_Tashkent,
        value: "Asia/Tashkent",
        label: "Asia/Tashkent",
    },
    {
        key: TimeZoneEnum.Asia_Tbilisi,
        value: "Asia/Tbilisi",
        label: "Asia/Tbilisi",
    },
    {
        key: TimeZoneEnum.Asia_Tehran,
        value: "Asia/Tehran",
        label: "Asia/Tehran",
    },
    {
        key: TimeZoneEnum.Asia_Thimphu,
        value: "Asia/Thimphu",
        label: "Asia/Thimphu",
    },
    {
        key: TimeZoneEnum.Asia_Tokyo,
        value: "Asia/Tokyo",
        label: "Asia/Tokyo",
    },
    {
        key: TimeZoneEnum.Asia_Tomsk,
        value: "Asia/Tomsk",
        label: "Asia/Tomsk",
    },
    {
        key: TimeZoneEnum.Asia_Ulaanbaatar,
        value: "Asia/Ulaanbaatar",
        label: "Asia/Ulaanbaatar",
    },
    {
        key: TimeZoneEnum.Asia_Urumqi,
        value: "Asia/Urumqi",
        label: "Asia/Urumqi",
    },
    {
        key: TimeZoneEnum.Asia_Ust_Nera,
        value: "Asia/Ust-Nera",
        label: "Asia/Ust-Nera",
    },
    {
        key: TimeZoneEnum.Asia_Vientiane,
        value: "Asia/Vientiane",
        label: "Asia/Vientiane",
    },
    {
        key: TimeZoneEnum.Asia_Vladivostok,
        value: "Asia/Vladivostok",
        label: "Asia/Vladivostok",
    },
    {
        key: TimeZoneEnum.Asia_Yakutsk,
        value: "Asia/Yakutsk",
        label: "Asia/Yakutsk",
    },
    {
        key: TimeZoneEnum.Asia_Yangon,
        value: "Asia/Yangon",
        label: "Asia/Yangon",
    },
    {
        key: TimeZoneEnum.Asia_Yekaterinburg,
        value: "Asia/Yekaterinburg",
        label: "Asia/Yekaterinburg",
    },
    {
        key: TimeZoneEnum.Asia_Yerevan,
        value: "Asia/Yerevan",
        label: "Asia/Yerevan",
    },
    {
        key: TimeZoneEnum.Atlantic_Azores,
        value: "Atlantic/Azores",
        label: "Atlantic/Azores",
    },
    {
        key: TimeZoneEnum.Atlantic_Bermuda,
        value: "Atlantic/Bermuda",
        label: "Atlantic/Bermuda",
    },
    {
        key: TimeZoneEnum.Atlantic_Canary,
        value: "Atlantic/Canary",
        label: "Atlantic/Canary",
    },
    {
        key: TimeZoneEnum.Atlantic_Cape_Verde,
        value: "Atlantic/Cape_Verde",
        label: "Atlantic/Cape_Verde",
    },
    {
        key: TimeZoneEnum.Atlantic_Faroe,
        value: "Atlantic/Faroe",
        label: "Atlantic/Faroe",
    },
    {
        key: TimeZoneEnum.Atlantic_Madeira,
        value: "Atlantic/Madeira",
        label: "Atlantic/Madeira",
    },
    {
        key: TimeZoneEnum.Atlantic_Reykjavik,
        value: "Atlantic/Reykjavik",
        label: "Atlantic/Reykjavik",
    },
    {
        key: TimeZoneEnum.Atlantic_South_Georgia,
        value: "Atlantic/South_Georgia",
        label: "Atlantic/South_Georgia",
    },
    {
        key: TimeZoneEnum.Atlantic_St_Helena,
        value: "Atlantic/St_Helena",
        label: "Atlantic/St_Helena",
    },
    {
        key: TimeZoneEnum.Atlantic_Stanley,
        value: "Atlantic/Stanley",
        label: "Atlantic/Stanley",
    },
    {
        key: TimeZoneEnum.Australia_Adelaide,
        value: "Australia/Adelaide",
        label: "Australia/Adelaide",
    },
    {
        key: TimeZoneEnum.Australia_Brisbane,
        value: "Australia/Brisbane",
        label: "Australia/Brisbane",
    },
    {
        key: TimeZoneEnum.Australia_Broken_Hill,
        value: "Australia/Broken_Hill",
        label: "Australia/Broken_Hill",
    },
    {
        key: TimeZoneEnum.Australia_Darwin,
        value: "Australia/Darwin",
        label: "Australia/Darwin",
    },
    {
        key: TimeZoneEnum.Australia_Eucla,
        value: "Australia/Eucla",
        label: "Australia/Eucla",
    },
    {
        key: TimeZoneEnum.Australia_Hobart,
        value: "Australia/Hobart",
        label: "Australia/Hobart",
    },
    {
        key: TimeZoneEnum.Australia_Lindeman,
        value: "Australia/Lindeman",
        label: "Australia/Lindeman",
    },
    {
        key: TimeZoneEnum.Australia_Lord_Howe,
        value: "Australia/Lord_Howe",
        label: "Australia/Lord_Howe",
    },
    {
        key: TimeZoneEnum.Australia_Melbourne,
        value: "Australia/Melbourne",
        label: "Australia/Melbourne",
    },
    {
        key: TimeZoneEnum.Australia_Perth,
        value: "Australia/Perth",
        label: "Australia/Perth",
    },
    {
        key: TimeZoneEnum.Australia_Sydney,
        value: "Australia/Sydney",
        label: "Australia/Sydney",
    },
    {
        key: TimeZoneEnum.Europe_Amsterdam,
        value: "Europe/Amsterdam",
        label: "Europe/Amsterdam",
    },
    {
        key: TimeZoneEnum.Europe_Andorra,
        value: "Europe/Andorra",
        label: "Europe/Andorra",
    },
    {
        key: TimeZoneEnum.Europe_Astrakhan,
        value: "Europe/Astrakhan",
        label: "Europe/Astrakhan",
    },
    {
        key: TimeZoneEnum.Europe_Athens,
        value: "Europe/Athens",
        label: "Europe/Athens",
    },
    {
        key: TimeZoneEnum.Europe_Belgrade,
        value: "Europe/Belgrade",
        label: "Europe/Belgrade",
    },
    {
        key: TimeZoneEnum.Europe_Berlin,
        value: "Europe/Berlin",
        label: "Europe/Berlin",
    },
    {
        key: TimeZoneEnum.Europe_Bratislava,
        value: "Europe/Bratislava",
        label: "Europe/Bratislava",
    },
    {
        key: TimeZoneEnum.Europe_Brussels,
        value: "Europe/Brussels",
        label: "Europe/Brussels",
    },
    {
        key: TimeZoneEnum.Europe_Bucharest,
        value: "Europe/Bucharest",
        label: "Europe/Bucharest",
    },
    {
        key: TimeZoneEnum.Europe_Budapest,
        value: "Europe/Budapest",
        label: "Europe/Budapest",
    },
    {
        key: TimeZoneEnum.Europe_Busingen,
        value: "Europe/Busingen",
        label: "Europe/Busingen",
    },
    {
        key: TimeZoneEnum.Europe_Chisinau,
        value: "Europe/Chisinau",
        label: "Europe/Chisinau",
    },
    {
        key: TimeZoneEnum.Europe_Copenhagen,
        value: "Europe/Copenhagen",
        label: "Europe/Copenhagen",
    },
    {
        key: TimeZoneEnum.Europe_Dublin,
        value: "Europe/Dublin",
        label: "Europe/Dublin",
    },
    {
        key: TimeZoneEnum.Europe_Gibraltar,
        value: "Europe/Gibraltar",
        label: "Europe/Gibraltar",
    },
    {
        key: TimeZoneEnum.Europe_Guernsey,
        value: "Europe/Guernsey",
        label: "Europe/Guernsey",
    },
    {
        key: TimeZoneEnum.Europe_Helsinki,
        value: "Europe/Helsinki",
        label: "Europe/Helsinki",
    },
    {
        key: TimeZoneEnum.Europe_Isle_of_Man,
        value: "Europe/Isle_of_Man",
        label: "Europe/Isle_of_Man",
    },
    {
        key: TimeZoneEnum.Europe_Istanbul,
        value: "Europe/Istanbul",
        label: "Europe/Istanbul",
    },
    {
        key: TimeZoneEnum.Europe_Jersey,
        value: "Europe/Jersey",
        label: "Europe/Jersey",
    },
    {
        key: TimeZoneEnum.Europe_Kaliningrad,
        value: "Europe/Kaliningrad",
        label: "Europe/Kaliningrad",
    },
    {
        key: TimeZoneEnum.Europe_Kirov,
        value: "Europe/Kirov",
        label: "Europe/Kirov",
    },
    {
        key: TimeZoneEnum.Europe_Kyiv,
        value: "Europe/Kyiv",
        label: "Europe/Kyiv",
    },
    {
        key: TimeZoneEnum.Europe_Lisbon,
        value: "Europe/Lisbon",
        label: "Europe/Lisbon",
    },
    {
        key: TimeZoneEnum.Europe_Ljubljana,
        value: "Europe/Ljubljana",
        label: "Europe/Ljubljana",
    },
    {
        key: TimeZoneEnum.Europe_London,
        value: "Europe/London",
        label: "Europe/London",
    },
    {
        key: TimeZoneEnum.Europe_Luxembourg,
        value: "Europe/Luxembourg",
        label: "Europe/Luxembourg",
    },
    {
        key: TimeZoneEnum.Europe_Madrid,
        value: "Europe/Madrid",
        label: "Europe/Madrid",
    },
    {
        key: TimeZoneEnum.Europe_Malta,
        value: "Europe/Malta",
        label: "Europe/Malta",
    },
    {
        key: TimeZoneEnum.Europe_Mariehamn,
        value: "Europe/Mariehamn",
        label: "Europe/Mariehamn",
    },
    {
        key: TimeZoneEnum.Europe_Minsk,
        value: "Europe/Minsk",
        label: "Europe/Minsk",
    },
    {
        key: TimeZoneEnum.Europe_Monaco,
        value: "Europe/Monaco",
        label: "Europe/Monaco",
    },
    {
        key: TimeZoneEnum.Europe_Moscow,
        value: "Europe/Moscow",
        label: "Europe/Moscow",
    },
    {
        key: TimeZoneEnum.Europe_Oslo,
        value: "Europe/Oslo",
        label: "Europe/Oslo",
    },
    {
        key: TimeZoneEnum.Europe_Paris,
        value: "Europe/Paris",
        label: "Europe/Paris",
    },
    {
        key: TimeZoneEnum.Europe_Podgorica,
        value: "Europe/Podgorica",
        label: "Europe/Podgorica",
    },
    {
        key: TimeZoneEnum.Europe_Prague,
        value: "Europe/Prague",
        label: "Europe/Prague",
    },
    {
        key: TimeZoneEnum.Europe_Riga,
        value: "Europe/Riga",
        label: "Europe/Riga",
    },
    {
        key: TimeZoneEnum.Europe_Rome,
        value: "Europe/Rome",
        label: "Europe/Rome",
    },
    {
        key: TimeZoneEnum.Europe_Samara,
        value: "Europe/Samara",
        label: "Europe/Samara",
    },
    {
        key: TimeZoneEnum.Europe_San_Marino,
        value: "Europe/San_Marino",
        label: "Europe/San_Marino",
    },
    {
        key: TimeZoneEnum.Europe_Sarajevo,
        value: "Europe/Sarajevo",
        label: "Europe/Sarajevo",
    },
    {
        key: TimeZoneEnum.Europe_Saratov,
        value: "Europe/Saratov",
        label: "Europe/Saratov",
    },
    {
        key: TimeZoneEnum.Europe_Simferopol,
        value: "Europe/Simferopol",
        label: "Europe/Simferopol",
    },
    {
        key: TimeZoneEnum.Europe_Skopje,
        value: "Europe/Skopje",
        label: "Europe/Skopje",
    },
    {
        key: TimeZoneEnum.Europe_Sofia,
        value: "Europe/Sofia",
        label: "Europe/Sofia",
    },
    {
        key: TimeZoneEnum.Europe_Stockholm,
        value: "Europe/Stockholm",
        label: "Europe/Stockholm",
    },
    {
        key: TimeZoneEnum.Europe_Tallinn,
        value: "Europe/Tallinn",
        label: "Europe/Tallinn",
    },
    {
        key: TimeZoneEnum.Europe_Tirane,
        value: "Europe/Tirane",
        label: "Europe/Tirane",
    },
    {
        key: TimeZoneEnum.Europe_Ulyanovsk,
        value: "Europe/Ulyanovsk",
        label: "Europe/Ulyanovsk",
    },
    {
        key: TimeZoneEnum.Europe_Vaduz,
        value: "Europe/Vaduz",
        label: "Europe/Vaduz",
    },
    {
        key: TimeZoneEnum.Europe_Vatican,
        value: "Europe/Vatican",
        label: "Europe/Vatican",
    },
    {
        key: TimeZoneEnum.Europe_Vienna,
        value: "Europe/Vienna",
        label: "Europe/Vienna",
    },
    {
        key: TimeZoneEnum.Europe_Vilnius,
        value: "Europe/Vilnius",
        label: "Europe/Vilnius",
    },
    {
        key: TimeZoneEnum.Europe_Volgograd,
        value: "Europe/Volgograd",
        label: "Europe/Volgograd",
    },
    {
        key: TimeZoneEnum.Europe_Warsaw,
        value: "Europe/Warsaw",
        label: "Europe/Warsaw",
    },
    {
        key: TimeZoneEnum.Europe_Zagreb,
        value: "Europe/Zagreb",
        label: "Europe/Zagreb",
    },
    {
        key: TimeZoneEnum.Europe_Zurich,
        value: "Europe/Zurich",
        label: "Europe/Zurich",
    },
    {
        key: TimeZoneEnum.Indian_Antananarivo,
        value: "Indian/Antananarivo",
        label: "Indian/Antananarivo",
    },
    {
        key: TimeZoneEnum.Indian_Chagos,
        value: "Indian/Chagos",
        label: "Indian/Chagos",
    },
    {
        key: TimeZoneEnum.Indian_Christmas,
        value: "Indian/Christmas",
        label: "Indian/Christmas",
    },
    {
        key: TimeZoneEnum.Indian_Cocos,
        value: "Indian/Cocos",
        label: "Indian/Cocos",
    },
    {
        key: TimeZoneEnum.Indian_Comoro,
        value: "Indian/Comoro",
        label: "Indian/Comoro",
    },
    {
        key: TimeZoneEnum.Indian_Kerguelen,
        value: "Indian/Kerguelen",
        label: "Indian/Kerguelen",
    },
    {
        key: TimeZoneEnum.Indian_Mahe,
        value: "Indian/Mahe",
        label: "Indian/Mahe",
    },
    {
        key: TimeZoneEnum.Indian_Maldives,
        value: "Indian/Maldives",
        label: "Indian/Maldives",
    },
    {
        key: TimeZoneEnum.Indian_Mauritius,
        value: "Indian/Mauritius",
        label: "Indian/Mauritius",
    },
    {
        key: TimeZoneEnum.Indian_Mayotte,
        value: "Indian/Mayotte",
        label: "Indian/Mayotte",
    },
    {
        key: TimeZoneEnum.Indian_Reunion,
        value: "Indian/Reunion",
        label: "Indian/Reunion",
    },
    {
        key: TimeZoneEnum.Pacific_Apia,
        value: "Pacific/Apia",
        label: "Pacific/Apia",
    },
    {
        key: TimeZoneEnum.Pacific_Auckland,
        value: "Pacific/Auckland",
        label: "Pacific/Auckland",
    },
    {
        key: TimeZoneEnum.Pacific_Bougainville,
        value: "Pacific/Bougainville",
        label: "Pacific/Bougainville",
    },
    {
        key: TimeZoneEnum.Pacific_Chatham,
        value: "Pacific/Chatham",
        label: "Pacific/Chatham",
    },
    {
        key: TimeZoneEnum.Pacific_Chuuk,
        value: "Pacific/Chuuk",
        label: "Pacific/Chuuk",
    },
    {
        key: TimeZoneEnum.Pacific_Easter,
        value: "Pacific/Easter",
        label: "Pacific/Easter",
    },
    {
        key: TimeZoneEnum.Pacific_Efate,
        value: "Pacific/Efate",
        label: "Pacific/Efate",
    },
    {
        key: TimeZoneEnum.Pacific_Fakaofo,
        value: "Pacific/Fakaofo",
        label: "Pacific/Fakaofo",
    },
    {
        key: TimeZoneEnum.Pacific_Fiji,
        value: "Pacific/Fiji",
        label: "Pacific/Fiji",
    },
    {
        key: TimeZoneEnum.Pacific_Funafuti,
        value: "Pacific/Funafuti",
        label: "Pacific/Funafuti",
    },
    {
        key: TimeZoneEnum.Pacific_Galapagos,
        value: "Pacific/Galapagos",
        label: "Pacific/Galapagos",
    },
    {
        key: TimeZoneEnum.Pacific_Gambier,
        value: "Pacific/Gambier",
        label: "Pacific/Gambier",
    },
    {
        key: TimeZoneEnum.Pacific_Guadalcanal,
        value: "Pacific/Guadalcanal",
        label: "Pacific/Guadalcanal",
    },
    {
        key: TimeZoneEnum.Pacific_Guam,
        value: "Pacific/Guam",
        label: "Pacific/Guam",
    },
    {
        key: TimeZoneEnum.Pacific_Honolulu,
        value: "Pacific/Honolulu",
        label: "Pacific/Honolulu",
    },
    {
        key: TimeZoneEnum.Pacific_Kanton,
        value: "Pacific/Kanton",
        label: "Pacific/Kanton",
    },
    {
        key: TimeZoneEnum.Pacific_Kiritimati,
        value: "Pacific/Kiritimati",
        label: "Pacific/Kiritimati",
    },
    {
        key: TimeZoneEnum.Pacific_Kosrae,
        value: "Pacific/Kosrae",
        label: "Pacific/Kosrae",
    },
    {
        key: TimeZoneEnum.Pacific_Kwajalein,
        value: "Pacific/Kwajalein",
        label: "Pacific/Kwajalein",
    },
    {
        key: TimeZoneEnum.Pacific_Majuro,
        value: "Pacific/Majuro",
        label: "Pacific/Majuro",
    },
    {
        key: TimeZoneEnum.Pacific_Marquesas,
        value: "Pacific/Marquesas",
        label: "Pacific/Marquesas",
    },
    {
        key: TimeZoneEnum.Pacific_Midway,
        value: "Pacific/Midway",
        label: "Pacific/Midway",
    },
    {
        key: TimeZoneEnum.Pacific_Nauru,
        value: "Pacific/Nauru",
        label: "Pacific/Nauru",
    },
    {
        key: TimeZoneEnum.Pacific_Niue,
        value: "Pacific/Niue",
        label: "Pacific/Niue",
    },
    {
        key: TimeZoneEnum.Pacific_Norfolk,
        value: "Pacific/Norfolk",
        label: "Pacific/Norfolk",
    },
    {
        key: TimeZoneEnum.Pacific_Noumea,
        value: "Pacific/Noumea",
        label: "Pacific/Noumea",
    },
    {
        key: TimeZoneEnum.Pacific_Pago_Pago,
        value: "Pacific/Pago_Pago",
        label: "Pacific/Pago_Pago",
    },
    {
        key: TimeZoneEnum.Pacific_Palau,
        value: "Pacific/Palau",
        label: "Pacific/Palau",
    },
    {
        key: TimeZoneEnum.Pacific_Pitcairn,
        value: "Pacific/Pitcairn",
        label: "Pacific/Pitcairn",
    },
    {
        key: TimeZoneEnum.Pacific_Pohnpei,
        value: "Pacific/Pohnpei",
        label: "Pacific/Pohnpei",
    },
    {
        key: TimeZoneEnum.Pacific_Port_Moresby,
        value: "Pacific/Port_Moresby",
        label: "Pacific/Port_Moresby",
    },
    {
        key: TimeZoneEnum.Pacific_Rarotonga,
        value: "Pacific/Rarotonga",
        label: "Pacific/Rarotonga",
    },
    {
        key: TimeZoneEnum.Pacific_Saipan,
        value: "Pacific/Saipan",
        label: "Pacific/Saipan",
    },
    {
        key: TimeZoneEnum.Pacific_Tahiti,
        value: "Pacific/Tahiti",
        label: "Pacific/Tahiti",
    },
    {
        key: TimeZoneEnum.Pacific_Tarawa,
        value: "Pacific/Tarawa",
        label: "Pacific/Tarawa",
    },
    {
        key: TimeZoneEnum.Pacific_Tongatapu,
        value: "Pacific/Tongatapu",
        label: "Pacific/Tongatapu",
    },
    {
        key: TimeZoneEnum.Pacific_Wake,
        value: "Pacific/Wake",
        label: "Pacific/Wake",
    },
    {
        key: TimeZoneEnum.Pacific_Wallis,
        value: "Pacific/Wallis",
        label: "Pacific/Wallis",
    },
    {
        key: TimeZoneEnum.UTC,
        value: "UTC",
        label: "UTC",
    },
] as const

export type TimeZoneEnumDataEntry = typeof TimeZoneEnumData[TimeZoneEnum]
export type TimeZoneEnumListEntry = typeof TimeZoneEnumList[number]
export type TimeZoneEnumListType = typeof TimeZoneEnumList
